
export enum TradePlatformType_WithDeprecated {
	'ACT' = '1',
	'MT4' = '2',
	'FOREX_TRADER' = '3',
	'IFP_GAMING' = '4',
	'MULTI_TRADER' = '5',
	'WEB_FX' = '6',
	'SPOT_OPTION' = '8',
	'COSMOS' = '11',
	'BINARYOPTIONS' = '14',
	'PLUS500' = '15',
	'MT5' = '16',
	'TTA' = '17',
	'DMA' = '18'
}

export enum TradePlatformType_Deprecated {
	'ACT' = '1',
	'FOREX_TRADER' = '3',
	'IFP_GAMING' = '4',
	'MULTI_TRADER' = '5',
	'WEB_FX' = '6',
	'SPOT_OPTION' = '8',
	'BINARYOPTIONS' = '14',
	'PLUS500' = '15'
}

export enum TradePlatformType {
	'MT4' = '2',
	'COSMOS' = '11',
	'MT5' = '16',
	'TTA' = '17',
	'DMA' = '18'
}

export enum TradingEligibilityTestStatusType {
	'PASSED' = '1',
	'PASSED_QUIZ_2' = '3',
	'PASSED_QUIZ_3' = '5',
	'FAILED' = '0',
	'FAILED_QUIZ_2' = '2',
	'FAILED_QUIZ_3' = '4'
}

export enum PoolType {
	'UNDEFINED' = '0',
	'SALES' = '1',
	'RETENTION' = '2',
	'OTHER' = '3'
}

export enum AlertName {
	'HIGH_LOW_ASC_RPUQ' = 'High-Low Aml Score Category - Request PUQ',
	'HIGH_LOW_ASC_RTPSD' = 'High-Low Aml Score Category - Request TPSD',
	'HIGH_LOW_ASC_RRL' = 'High-Low Aml Score Category - Request RL',
	'HIGH_MEDIUM_ASC_RPUQ' = 'High-Medium Aml Score Category - Request PUQ',
	'HIGH_MEDIUM_ASC_RTPSD' = 'High-Medium Aml Score Category - Request TPSD',
	'HIGH_MEDIUM_ASC_RRL' = 'High-Medium Aml Score Category - Request RL',
	'HIGH_HIGH_ASC_RTPSD' = 'High-High Aml Score Category - Request TPSD',
	'HIGH_HIGH_ASC_RRL' = 'High-High Aml Score Category - Request RL',
	'PROFILE_UPDATE_QUESTIONNAIRE_PUQ' = 'Profile Update Questionnaire (PUQ)',
	'DEVIATION_FROM_ECONOMIC_PROFILE' = 'Deviation from the Economic profile',
	'DEPOSIT_FROM_HIGH_RISK_COUNTRY' = 'Deposit from High-Risk Country',
	'RAPID_FIRE_TRANSACTIONS' = 'Rapid fire transactions',
	'SPLIT_TRANSACTIONS_WITH_AMOUNT_THRESHOLD' = 'Split transactions with amount threshold',
	'CLIENT_IS_DORMANT_FOR_MORE_THAN_2_YEARS' = 'Client is dormant for more than 2 years',
	'HIGH_TRAFFIC_NO_TRADING' = 'High Traffic No trading',
	'GIFT_AND_ABOVE_FIVE_THOUSAND_DEPOSIT' = 'Gift and above five thousand deposit',
	'ECONOMIC_PROFILE_SHOULD_BE_UPDATED' = 'Economic profile should be updated'
}

export enum CIType {
	'LOGIN' = '1',
	'LOGOUT' = '2'
}

export enum CISource {
	'WEBSITE' = '1',
	'WEBSITE_LOGIN' = '2',
	'MT4_CLIENT' = '3',
	'SAS' = '4',
	'CRM' = '5',
	'EXACT_TARGET' = '6',
	'C_PATTERN' = '7',
	'WEBSITE_REGISTRATION' = '8',
	'MT5_CLIENT' = '9',
	'ANDROID' = '10',
	'IOS' = '11',
	'NA' = '12'
}

export enum Medium {
	'INTERNAL' = 'internal',
	'MAIL' = 'mail',
	'PHONE' = 'phone',
	'LIVE_CHAT' = 'chat',
	'SMS' = 'sms',
	'MEETING' = 'meeting',
	'ZENDESK' = 'zendesk',
	'APP_POPUP' = 'app_popup',
	'APP_PUSH' = 'app_push',
	'RECORDING' = 'recording',
	'ZENDESK_CHAT' = 'zendesk_chat'
}

export enum RunningEnvironment {
	'DEVELOPMENT' = '1',
	'QA' = '2',
	'PRODUCTION' = '3'
}

export enum Language {
	'OTHER' = '00',
	'ALBANIAN' = 'sq',
	'ARABIC' = 'ar',
	'BULGARIAN' = 'bg',
	'CATALAN' = 'ca',
	'CHINESE' = 'zh',
	'CHINESETR' = 'zt',
	'CROATIAN' = 'hr',
	'CZECH' = 'cs',
	'DANISH' = 'da',
	'DUTCH' = 'nl',
	'ENGLISH' = 'en',
	'ESTONIAN' = 'et',
	'FINNISH' = 'fi',
	'FRENCH' = 'fr',
	'GALICIAN' = 'gl',
	'GERMAN' = 'de',
	'GREEK' = 'el',
	'HEBREW' = 'he',
	'HINDI' = 'hi',
	'HUNGARIAN' = 'hu',
	'INDONESIAN' = 'id',
	'ITALIAN' = 'it',
	'JAPANESE' = 'ja',
	'KOREAN' = 'ko',
	'LATVIAN' = 'lv',
	'LITHUANIAN' = 'lt',
	'MALAY' = 'ms',
	'MALTESE' = 'mt',
	'NORWEGIAN' = 'no',
	'PERSIAN' = 'fa',
	'POLISH' = 'pl',
	'PORTUGUESE' = 'pt',
	'PUNJABI' = 'pa',
	'ROMANIAN' = 'ro',
	'RUSSIAN' = 'ru',
	'SERBIAN' = 'sr',
	'SLOVAK' = 'sk',
	'SLOVENIAN' = 'sl',
	'SPANISH' = 'es',
	'SWEDISH' = 'sv',
	'TAGALOG' = 'tl',
	'THAI' = 'th',
	'TURKISH' = 'tr',
	'UKRAINIAN' = 'uk',
	'URDU' = 'ur',
	'VIETNAMESE' = 'vi'
}

export enum AlertType {
	'GENERAL' = '1',
	'ARROW' = '2'
}

export enum PaymentMethodsType {
	'CREDIT_CARD' = 'CreditCard',
	'WIRETRANSFER' = 'Wiretransfer',
	'CRYPTO' = 'Crypto',
	'APPLE_PAY' = 'ApplePay',
	'NETELER' = 'Neteller',
	'SKRILL' = 'Skrill',
	'GOOGLE_PAY' = 'GooglePay',
	'BINANCE_PAY' = 'BinancePay',
	'PAY_RETAILERS' = 'PayRetailers',
	'PAYMENT_ASIA' = 'PaymentAsia',
	'VERTU_PAY' = 'VertuPay',
	'HELP2_PAY' = 'Help2Pay',
	'AO_PAY' = 'AoPay',
	'DIGITAL_CRYPTO_PAY' = 'DigitalCryptoPay',
	'CENTIWISE' = 'Centiwise'
}

export enum SourceSystem {
	'CRM' = 'CRM',
	'SPA' = 'SPA',
	'RPA' = 'RPA'
}

export enum AlertStage {
	'NOT_TRIGGERED_ARROW' = '0',
	'TRIGGERED_PUQ_1ST_NOTICE' = '1',
	'TRIGGERED_PUQ_2ND_NOTICE' = '2',
	'PUQ_APPROVED' = '3',
	'PUQ_DECLINED' = '4',
	'PUQ_PENDING_FOR_REVIEW' = '5',
	'PUQ_NON_RESPONDED_CLIENTS' = '6',
	'TRIGGERED_TPSD_1ST_NOTICE' = '7',
	'TRIGGERED_TPSD_2ND_NOTICE' = '8',
	'TPSD_APPROVED' = '9',
	'TPSD_DECLINED' = '10',
	'TPSD_PENDING_FOR_REVIEW' = '11',
	'TPSD_NON_RESPONDED_CLIENTS' = '12',
	'TRIGGERED_RL_1ST_NOTICE' = '13',
	'TRIGGERED_RL_2ND_NOTICE' = '14',
	'RL_APPROVED' = '15',
	'RL_DECLINED' = '16',
	'RL_PENDING_FOR_REVIEW' = '17',
	'RL_NON_RESPONDED_CLIENTS' = '18'
}

export enum MaritalStatus {
	'SINGLE' = '0',
	'MARRIED' = '1',
	'ENGAGED' = '2',
	'DIVORCED' = '3',
	'SEPARATED' = '4',
	'WIDOW' = '5',
	'UNKNOWN' = '6'
}

export enum NonEngagedType {
	'DISQUALIFIED' = 'Disqualified',
	'BURNOUT' = 'Burnout',
	'TRASH' = 'Trash'
}

export enum Gender {
	'UNKNOWN' = '0',
	'MALE' = '1',
	'FEMALE' = '2'
}

export enum PaymentProcessorsType {
	'AOPAY' = 'aopay',
	'APS' = 'aps',
	'BRIDGERPAY' = 'bridgerpay',
	'PAYRETAILERS' = 'payretailers',
	'PRAXIS' = 'praxis',
	'LETKNOW' = 'letknow',
	'NETELLER' = 'neteller',
	'NUVEI' = 'nuvei',
	'WIRETRANSFER' = 'wiretransfer',
	'SKRILL' = 'skrill',
	'VIRTUAL_PAY' = 'virtualPay',
	'TRUST_PAYMENT' = 'trustPayment',
	'CENTIWISE' = 'centiwise',
	'STANDARD_BANK' = 'standardBank',
	'PAYMENT_ASIA' = 'paymentAsia',
	'VERTU_PAY' = 'vertuPay',
	'HELP2_PAY' = 'help2Pay',
	'DIGITAL_CRYPTO_PAY' = 'digitalCryptoPay'
}

export enum VerificationStatus {
	'UNKNOWN' = '1',
	'VERIFIED' = '2',
	'NOT_VERIFIED' = '5',
	'INVALID' = '3',
	'VERIFIED_BY_SMS' = '4'
}

export enum Currency {
	'USD' = 'USD',
	'EUR' = 'EUR',
	'GBP' = 'GBP',
	'CAD' = 'CAD',
	'JPY' = 'JPY',
	'AED' = 'AED',
	'PLN' = 'PLN',
	'AZN' = 'AZN',
	'INR' = 'INR',
	'NZD' = 'NZD',
	'CUP' = 'CUP',
	'EGP' = 'EGP',
	'LBP' = 'LBP',
	'RMB' = 'RMB',
	'AUD' = 'AUD',
	'ILS' = 'ILS',
	'RON' = 'RON',
	'CHF' = 'CHF',
	'CZK' = 'CZK',
	'DKK' = 'DKK',
	'RUB' = 'RUB',
	'BGN' = 'BGN',
	'HRK' = 'HRK',
	'CNY' = 'CNY',
	'MXN' = 'MXN',
	'CLP' = 'CLP',
	'ALL' = 'ALL',
	'NOK' = 'NOK',
	'SEK' = 'SEK',
	'HUF' = 'HUF',
	'BRL' = 'BRL',
	'ZAR' = 'ZAR',
	'HKD' = 'HKD',
	'SGD' = 'SGD',
	'THB' = 'THB',
	'TRY' = 'TRY',
	'KRW' = 'KRW',
	'SKK' = 'SKK',
	'LKR' = 'LKR',
	'COP' = 'COP',
	'VND' = 'VND',
	'CNH' = 'CNH',
	'SAR' = 'SAR',
	'MYR' = 'MYR',
	'USDT' = 'USDT',
	'LOCAL_CURRENCY' = 'LCY'
}

export enum ContactAvailableMethod {
	'NONE' = '0',
	'EMAIL_ONLY' = '1',
	'PHONE_ONLY' = '2',
	'EMAIL_AND_PHONE' = '3'
}

export enum LogicalOperator {
	'And' = '0',
	'Or' = '1'
}

export enum TradePlatformAdvancedType_WithDeprecated {
	'MT4' = '2',
	'MT5' = '16',
	'COSMOS_WEB' = '11',
	'COSMOS_MOBILE' = '11',
	'TTA' = '17',
	'SAXO' = '18',
	'ACT' = '1',
	'FOREX_TRADER' = '3',
	'IFP_GAMING' = '4',
	'MULTI_TRADER' = '5',
	'WEB_FX' = '6',
	'SPOT_OPTION' = '8',
	'BINARYOPTIONS' = '14',
	'PLUS500' = '15'
}

export enum TradePlatformAdvancedType_Deprecated {
	'ACT' = '1',
	'FOREX_TRADER' = '3',
	'IFP_GAMING' = '4',
	'MULTI_TRADER' = '5',
	'WEB_FX' = '6',
	'SPOT_OPTION' = '8',
	'BINARYOPTIONS' = '14',
	'PLUS500' = '15'
}

export enum TradePlatformAdvancedType {
	'MT4' = '2',
	'MT5' = '16',
	'COSMOS_WEB' = '11',
	'COSMOS_MOBILE' = '11',
	'TTA' = '17',
	'SAXO' = '18'
}

export enum CashierType {
	'NUVEI' = '0',
	'PRAXIS' = '1',
	'MD' = '2',
	'MD_OR_PRAXIS' = '3',
	'PRAXIS_OR_MD' = '4',
	'BRIDGERPAY' = '5',
	'BRIDGERPAY_OR_PRAXIS' = '6',
	'PRAXIS_OR_BRIDGERPAY' = '7',
	'BRIDGERPAY_OR_NUVEI' = '8',
	'NUVEI_OR_BRIDGERPAY' = '9'
}

export enum Country {
	'NA' = '00',
	'AFGHANISTAN' = 'af',
	'ÅLAND_ISLANDS' = 'ax',
	'ALBANIA' = 'al',
	'ALGERIA' = 'dz',
	'AMERICAN_SAMOA' = 'as',
	'ANDORRA' = 'ad',
	'ANGOLA' = 'ao',
	'ANGUILLA' = 'ai',
	'ANTARCTICA' = 'aq',
	'ANTIGUA_AND_BARBUDA' = 'ag',
	'ARGENTINA' = 'ar',
	'ARMENIA' = 'am',
	'ARUBA' = 'aw',
	'AUSTRALIA' = 'au',
	'AUSTRIA' = 'at',
	'AZERBAIJAN' = 'az',
	'BAHAMAS' = 'bs',
	'BAHRAIN' = 'bh',
	'BANGLADESH' = 'bd',
	'BARBADOS' = 'bb',
	'BELARUS' = 'by',
	'BELGIUM' = 'be',
	'BELIZE' = 'bz',
	'BENIN' = 'bj',
	'BERMUDA' = 'bm',
	'BHUTAN' = 'bt',
	'BOLIVIA' = 'bo',
	'BONAIRE_SINT_EUSTATIUS_AND_SABA' = 'bq',
	'BOSNIA_AND_HERZEGOVINA' = 'ba',
	'BOTSWANA' = 'bw',
	'BOUVET_ISLAND' = 'bv',
	'BRAZIL' = 'br',
	'BRITISH_INDIAN_OCEAN_TERRITORY' = 'io',
	'BRUNEI_DARUSSALAM' = 'bn',
	'BULGARIA' = 'bg',
	'BURKINA_FASO' = 'bf',
	'BURUNDI' = 'bi',
	'CAMBODIA' = 'kh',
	'CAMEROON' = 'cm',
	'CANADA' = 'ca',
	'CAPE_VERDE' = 'cv',
	'CAYMAN_ISLANDS' = 'ky',
	'CENTRAL_AFRICAN_REPUBLIC' = 'cf',
	'CHAD' = 'td',
	'CHILE' = 'cl',
	'CHINA' = 'cn',
	'CHRISTMAS_ISLAND' = 'cx',
	'COCOS_ISLANDS' = 'cc',
	'COLOMBIA' = 'co',
	'COMOROS' = 'km',
	'CONGO' = 'cg',
	'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' = 'cd',
	'COOK_ISLANDS' = 'ck',
	'COSTA_RICA' = 'cr',
	'CROATIA' = 'hr',
	'CUBA' = 'cu',
	'CURAÇAO' = 'cw',
	'CYPRUS' = 'cy',
	'CZECH_REPUBLIC' = 'cz',
	'CÔTE_DIVOIRE' = 'ci',
	'DENMARK' = 'dk',
	'DJIBOUTI' = 'dj',
	'DOMINICA' = 'dm',
	'DOMINICAN_REPUBLIC' = 'do',
	'EAST_TIMOR' = 'tl',
	'ECUADOR' = 'ec',
	'EGYPT' = 'eg',
	'EL_SALVADOR' = 'sv',
	'EQUATORIAL_GUINEA' = 'gq',
	'ERITREA' = 'er',
	'ESTONIA' = 'ee',
	'ETHIOPIA' = 'et',
	'FALKLAND_ISLANDS' = 'fk',
	'FAROE_ISLANDS' = 'fo',
	'FIJI' = 'fj',
	'FINLAND' = 'fi',
	'FRANCE' = 'fr',
	'FRENCH_GUIANA' = 'gf',
	'FRENCH_POLYNESIA' = 'pf',
	'FRENCH_SOUTHERN_TERRITORIES' = 'tf',
	'GABON' = 'ga',
	'GAMBIA' = 'gm',
	'Georgia' = 'ge',
	'GERMANY' = 'de',
	'GHANA' = 'gh',
	'GIBRALTAR' = 'gi',
	'GREECE' = 'gr',
	'GREENLAND' = 'gl',
	'GRENADA' = 'gd',
	'GUADELOUPE' = 'gp',
	'GUAM' = 'gu',
	'GUATEMALA' = 'gt',
	'GUERNSEY' = 'gg',
	'GUINEA' = 'gn',
	'GUINEA_BISSAU' = 'gw',
	'GUYANA' = 'gy',
	'HAITI' = 'ht',
	'HEARD_ISLAND_AND_MCDONALD_ISLANDS' = 'hm',
	'HONDURAS' = 'hn',
	'HONG_KONG' = 'hk',
	'Hungary' = 'hu',
	'ICELAND' = 'is',
	'INDIA' = 'in',
	'INDONESIA' = 'id',
	'IRAN' = 'ir',
	'IRAQ' = 'iq',
	'IRELAND' = 'ie',
	'ISLE_OF_MAN' = 'im',
	'ISRAEL' = 'il',
	'ITALY' = 'it',
	'JAMAICA' = 'jm',
	'JAPAN' = 'jp',
	'JERSEY' = 'je',
	'JORDAN' = 'jo',
	'KAZAKHSTAN' = 'kz',
	'KENYA' = 'ke',
	'KIRIBATI' = 'ki',
	'KOSOVO' = 'xk',
	'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' = 'kp',
	'KOREA_REPUBLIC_OF' = 'kr',
	'KUWAIT' = 'kw',
	'KYRGYZSTAN' = 'kg',
	'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' = 'la',
	'LATVIA' = 'lv',
	'LEBANON' = 'lb',
	'LESOTHO' = 'ls',
	'LIBERIA' = 'lr',
	'LIBYAN' = 'ly',
	'LIECHTENSTEIN' = 'li',
	'LITHUANIA' = 'lt',
	'LUXEMBOURG' = 'lu',
	'MACAO' = 'mo',
	'MADAGASCAR' = 'mg',
	'MALAWI' = 'mw',
	'MALAYSIA' = 'my',
	'MALDIVES' = 'mv',
	'MALI' = 'ml',
	'MALTA' = 'mt',
	'MARSHALL_ISLANDS' = 'mh',
	'MARTINIQUE' = 'mq',
	'MAURITANIA' = 'mr',
	'MAURITIUS' = 'mu',
	'MAYOTTE' = 'yt',
	'MEXICO' = 'mx',
	'MICRONESIA' = 'fm',
	'MOLDOVA_REPUBLIC_OF' = 'md',
	'MONACO' = 'mc',
	'MONGOLIA' = 'mn',
	'MONTENEGRO' = 'me',
	'MONTSERRAT' = 'ms',
	'MOROCCO' = 'ma',
	'MOZAMBIQUE' = 'mz',
	'MYANMAR' = 'mm',
	'NAMIBIA' = 'na',
	'NAURU' = 'nr',
	'NEPAL' = 'np',
	'NETHERLANDS' = 'nl',
	'NETHERLANDS_ANTILLES' = 'an',
	'NEW_CALEDONIA' = 'nc',
	'NEW_ZEALAND' = 'nz',
	'NICARAGUA' = 'ni',
	'NIGER' = 'ne',
	'NIGERIA' = 'ng',
	'NIUE' = 'nu',
	'NORFOLK_ISLAND' = 'nf',
	'NORTHERN_MARIANA_ISLANDS' = 'mp',
	'NORWAY' = 'no',
	'OMAN' = 'om',
	'PAKISTAN' = 'pk',
	'PALAU' = 'pw',
	'PALESTINIAN_TERRITORY_OCCUPIED' = 'ps',
	'PANAMA' = 'pa',
	'PAPUA_NEW_GUINEA' = 'pg',
	'PARAGUAY' = 'py',
	'PERU' = 'pe',
	'PHILIPPINES' = 'ph',
	'PITCAIRN' = 'pn',
	'POLAND' = 'pl',
	'PORTUGAL' = 'pt',
	'PUERTO_RICO' = 'pr',
	'QATAR' = 'qa',
	'ROMANIA' = 'ro',
	'RUSSIAN_FEDERATION' = 'ru',
	'RWANDA' = 'rw',
	'RÉUNION' = 're',
	'SAINT_BARTHÉLEMY_BL' = 'bl',
	'SAINT_HELENA' = 'sh',
	'SAINT_KITTS_AND_NEVIS' = 'kn',
	'SAINT_LUCIA' = 'lc',
	'SAINT_MARTIN_FRENCH_PART' = 'mf',
	'SAINT_PIERRE_AND_MIQUELON' = 'pm',
	'SAINT_VINCENT_AND_THE_GRENADINES' = 'vc',
	'SAMOA' = 'ws',
	'SAN_MARINO' = 'sm',
	'SAO_TOME_AND_PRINCIPE' = 'st',
	'SAUDI_ARABIA' = 'sa',
	'SENEGAL' = 'sn',
	'SERBIA' = 'rs',
	'SEYCHELLES' = 'sc',
	'SIERRA_LEONE' = 'sl',
	'SINGAPORE' = 'sg',
	'SINT_MAARTEN_DUTCH_PART' = 'sx',
	'SLOVAKIA' = 'sk',
	'SLOVENIA' = 'si',
	'SOLOMON_ISLANDS' = 'sb',
	'SOMALIA' = 'so',
	'SOUTH_AFRICA' = 'za',
	'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' = 'gs',
	'SOUTH_SUDAN' = 'ss',
	'SPAIN' = 'es',
	'SRI_LANKA' = 'lk',
	'SUDAN' = 'sd',
	'SURINAME' = 'sr',
	'SVALBARD_AND_JAN_MAYEN' = 'sj',
	'SWAZILAND' = 'sz',
	'SWEDEN' = 'se',
	'SWITZERLAND' = 'ch',
	'SYRIAN_ARAB_REPUBLIC' = 'sy',
	'TAIWAN' = 'tw',
	'TAJIKISTAN' = 'tj',
	'THAILAND' = 'th',
	'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' = 'mk',
	'TOGO' = 'tg',
	'TOKELAU' = 'tk',
	'TONGA' = 'to',
	'TRINIDAD_AND_TOBAGO' = 'tt',
	'TUNISIA' = 'tn',
	'TURKEY' = 'tr',
	'TURKMENISTAN' = 'tm',
	'TURKS_AND_CAICOS_ISLANDS' = 'tc',
	'TUVALU' = 'tv',
	'UGANDA' = 'ug',
	'UKRAINE' = 'ua',
	'UNITED_ARAB_EMIRATES' = 'ae',
	'UNITED_KINGDOM' = 'gb',
	'UNITED_REPUBLIC_OF_TANZANIA' = 'tz',
	'UNITED_STATES_MINOR_OUTLYING_ISLANDS' = 'um',
	'URUGUAY' = 'uy',
	'USA' = 'us',
	'UZBEKISTAN' = 'uz',
	'VANUATU' = 'vu',
	'VATICAN_CITY_STATE' = 'va',
	'VENEZUELA' = 've',
	'VIET_NAM' = 'vn',
	'VIRGIN_ISLANDS_GB' = 'vg',
	'VIRGIN_ISLANDS_USA' = 'vi',
	'WALLIS_AND_FUTUNA' = 'wf',
	'WESTERN_SAHARA' = 'eh',
	'YEMEN' = 'ye',
	'ZAMBIA' = 'zm',
	'ZIMBABWE' = 'zw'
}

export enum PhoneType {
	'UNKNOWN' = '0',
	'MOBILE' = '1',
	'LANDLINE' = '2',
	'FAX' = '3'
}

export enum NonEngagedAndTrash {
	'ALL' = 'All',
	'PENDING_LEAD' = 'Pending Lead',
	'PRE_LEAD' = 'Pre Lead',
	'PRE_ENGAGED' = 'Pre Engaged',
	'ENGAGED' = 'Engaged',
	'DISQUALIFIED' = 'Disqualified',
	'BURNOUT' = 'Burnout',
	'TRASH' = 'Trash'
}

export enum EmailValidationStatus {
	'NOT_CHECKED' = '1',
	'CHECKING' = '2',
	'FAILED' = '3',
	'VALID' = '4',
	'INVALID' = '5',
	'UNKNOWN' = '6'
}

export enum State {
	'NEW_YORK' = 'NY',
	'LOS_ANGELES' = 'LA'
}

export enum ApplicationType {
	'SPA' = '1',
	'RPA' = '2'
}

export enum ChinaUnionPaymentType {
	'WEBMONEY' = 'webmoney',
	'CASHU' = 'cashu',
	'TELEINGRESO' = 'teleingreso',
	'TODITOCARD' = 'toditocard',
	'TICKETSURF' = 'ticketsurf',
	'USEMYBANK' = 'usemybank',
	'SPOROPAY' = 'sporopay',
	'NEOSURF' = 'neosurf',
	'LOBANET' = 'lobanet',
	'MISTERCASH' = 'mistercash',
	'INSTADEBIT' = 'instadebit',
	'GLUEPAY' = 'gluepay',
	'GIROPAY' = 'giropay',
	'EUTELLER' = 'euteller',
	'EPS' = 'eps',
	'EPAY' = 'epay',
	'DINEROMAIL' = 'dineromail',
	'CACHU' = 'cachu',
	'BANKAXESS' = 'bankaxess',
	'ABAQOOS' = 'abaqoos',
	'IDEALGC' = 'idealgc',
	'IDEAL' = 'ideal',
	'POLI' = 'poli',
	'POLIGB' = 'poligb',
	'POLINZ' = 'polinz',
	'BANKLINK' = 'banklink',
	'BANKLINKSWED' = 'banklinkswed',
	'BOLETO' = 'boleto',
	'EKONTO' = 'ekonto',
	'EWIRESE' = 'ewirese',
	'EWIRENO' = 'ewireno',
	'EWIREDK' = 'ewiredk',
	'MULTIBANCO' = 'multibanco',
	'PRZELEWY' = 'przelewy',
	'MONETA' = 'moneta',
	'SOFORTUEBERWEISUNG' = 'sofortueberweisung',
	'BANKTRANSFER' = 'banktransfer',
	'MONEYBOOKERS' = 'moneybookers',
	'ASTROPAYCARD' = 'astropaycard',
	'KIWI' = 'Kiwi',
	'CHINAUNIONPAY' = 'ChainaUnionPay'
}

export enum AntiMoneyLaundryClassificationStatus {
	'LOW' = '0',
	'MEDIUM' = '1',
	'HIGH_LOW' = '2',
	'HIGH_MEDIUM' = '3',
	'HIGH_HIGH' = '4'
}

export enum PaymentAccountStatus {
	'PENDING' = '0',
	'APPROVED' = '1',
	'REJECTED' = '2',
	'BLACK_LISTED' = '3',
	'REVOKE_PENDING' = '5'
}

export enum QuestionnaireType {
	'COMPLIANCE' = '0',
	'AML' = '1',
	'EPA' = '2',
	'FULL_CUSTOMER_REGISTRATION' = '3',
	'ADDITIONAL_REGISTRATION' = '4',
	'PRODUCT' = '5'
}

export enum IncomeSource {
	'UNKNOWN' = '0',
	'SALARIED_EMPLOYEE' = '1',
	'SELF_EMPLOYEE' = '2',
	'RETIRED' = '6',
	'STUDENT' = '7',
	'UNEMPLOYED' = '8',
	'PENSION' = '3',
	'INVESTMENTS_AND_DIVIDENTS' = '4',
	'OTHER' = '5'
}

export enum CustomerDocumentType {
	'ADDITIONAL_RESEARCH' = '48',
	'API_AGREEMENT' = '56',
	'BANK_CONFIRMATION_LETTER' = '43',
	'CERTIFIED_PROOF_OF_ID' = '8',
	'CERTIFIED_PROOF_OF_RESIDENCE' = '9',
	'CLARIFICATIONS' = '72',
	'CLIENT_PROFILE_REVIEW' = '50',
	'CONTRACT_AGREEMENT' = '66',
	'CREDIT_CARD_BACK' = '5',
	'CREDIT_CARD_CANCELLATION_LETTER' = '31',
	'CREDIT_CARD_FRONT' = '4',
	'CREDIT_CARD_OWNERSHIP_LETTER' = '32',
	'CREDIT_CARD_SCREENSHOT_WITHIN_ONLINE_BANKING' = '33',
	'CREDIT_CARD_STATEMENT' = '34',
	'CREDIT_LINE_AGREEMENT' = '64',
	'DECLARATION_OF_ADDRESS' = '14',
	'DECLARATION_OF_FAMILY_MEMBER' = '15',
	'DMA_STATEMENT' = '71',
	'ELECTIVE_PROFESSIONAL_CLASSIFICATION_NOTICE' = '59',
	'ELECTIVE_PROFESSIONAL_QUESTIONNAIRE' = '60',
	'EMAIL' = '20',
	'EMIR_FORM' = '70',
	'ENHANCED_VERIFICATION_PROOF' = '42',
	'FINANCIAL_DOCUMENTS' = '49',
	'IB_AGREEMENT' = '51',
	'JOINT_ACCOUNT_FORM' = '35',
	'LANDLINE_MOBILE_PHONE_BILL' = '40',
	'MARRIAGE_CERTIFICATE' = '23',
	'MASTERFILE' = '52',
	'NDA' = '55',
	'NEGATIVE_BALANCE_PROTECTION' = '63',
	'PAYMENT_ADDENDUM' = '57',
	'PAYMENT_METHOD_CANCELLATION' = '39',
	'PAYMENT_METHOD_OWNERSHIP' = '38',
	'PER_SE_PROFESSIONAL_CLASSIFICATION_NOTICE' = '58',
	'PHONE_VERIFICATION' = '41',
	'POWER_OF_ATTORNEY' = '13',
	'PROFESSIONAL_CLIENT_APPLICATION' = '44',
	'PROFILE_UPDATE_QUESTIONNAIRE' = '45',
	'PROOF_OF_ID' = '1',
	'PROOF_OF_ID_BACK' = '37',
	'PROOF_OF_ID_FAMILY_MEMBER' = '22',
	'PROOF_OF_ID_FRONT' = '36',
	'PROOF_OF_RESIDENCE' = '2',
	'REFERENCE_LETTER' = '47',
	'SELFIE' = '67',
	'STATEMENTS_OF_DEPOSITS' = '7',
	'STATEMENT_REGARDING_MEETING' = '68',
	'SWAP_FREE_FORM' = '65',
	'SWIFT' = '18',
	'TECH_QUESTIONNAIRE' = '61',
	'THIRD_PARTY_CREDIT_CARD_AGREEMENT' = '17',
	'THIRD_PARTY_E_WALLET_AGREEMENT' = '26',
	'THIRD_PARTY_PROOF_OF_ID' = '24',
	'THIRD_PARTY_PROOF_OF_RESIDENCE' = '25',
	'THIRD_PARTY_SUPPORTING_EVIDENCE' = '46',
	'THIRD_PARTY_WIRE_TRANSFER_AGREEMENT' = '16',
	'TITLE_TRANSFER_AGREEMENT_FULL' = '53',
	'TITLE_TRANSFER_AGREEMENT_MARGIN_ONLY' = '54',
	'W8_FORM' = '69',
	'WAIVER_LETTER' = '21',
	'WIRE_TRANSFER_DOCUMENT' = '6',
	'WITHDRAWAL_REQUEST' = '3',
	'WOLFSBERG_FORM' = '62',
	'WORLD_CHECK_PASSOWRD_RESULT' = '11',
	'WORLD_CHECK_SEARCH_RESULT' = '10',
	'OTHER' = '12'
}

export enum SourceOfIncome {
	'NOT_RELEVANT' = '0',
	'SAVING' = '2',
	'PARTNER_PARENT_FAMILY' = '3',
	'BENEFITS_BORROWING' = '4',
	'PRIVATE_PENSION' = '5',
	'INVESTMENTS' = '6',
	'OTHER' = '1'
}

export enum PoolMemberType {
	'MEMBER' = '0',
	'MANAGER' = '1'
}

export enum CustomerEntityTypes {
	'Individual' = '0',
	'Corporate' = '1'
}

export enum PendingComplianceGround {
	'PENDING_ECDD' = '1',
	'PENDING_PHONE_VERIFICATION' = '2',
	'PENDING_NCI' = '3',
	'FOURTEEN_DAYS' = '4'
}

export enum FirstDepositPotential {
	'UNKNOWN' = '0',
	'FDP_0_100' = '1',
	'FDP_101_500' = '2',
	'FDP_501_1000' = '3',
	'FDP_1001_5000' = '4',
	'FDP_5001_10000' = '5',
	'FDP_10001_20000' = '6',
	'FDP_20001_50000' = '7',
	'FDP_50001_100000' = '8',
	'FDP_100001_500000' = '9',
	'FDP_OVER_500000' = '10'
}

export enum TaxJurisdiction {
	'NOT_RELEVANT' = '00',
	'NO_JURISDICTION' = 'n/j',
	'AFGHANISTAN' = 'af',
	'ÅLAND_ISLANDS' = 'ax',
	'ALBANIA' = 'al',
	'ALGERIA' = 'dz',
	'AMERICAN_SAMOA' = 'as',
	'ANDORRA' = 'ad',
	'ANGOLA' = 'ao',
	'ANGUILLA' = 'ai',
	'ANTARCTICA' = 'aq',
	'ANTIGUA_AND_BARBUDA' = 'ag',
	'ARGENTINA' = 'ar',
	'ARMENIA' = 'am',
	'ARUBA' = 'aw',
	'AUSTRALIA' = 'au',
	'AUSTRIA' = 'at',
	'AZERBAIJAN' = 'az',
	'BAHAMAS' = 'bs',
	'BAHRAIN' = 'bh',
	'BANGLADESH' = 'bd',
	'BARBADOS' = 'bb',
	'BELARUS' = 'by',
	'BELGIUM' = 'be',
	'BELIZE' = 'bz',
	'BENIN' = 'bj',
	'BERMUDA' = 'bm',
	'BHUTAN' = 'bt',
	'BOLIVIA' = 'bo',
	'BONAIRE_SINT_EUSTATIUS_AND_SABA' = 'bq',
	'BOSNIA_AND_HERZEGOVINA' = 'ba',
	'BOTSWANA' = 'bw',
	'BOUVET_ISLAND' = 'bv',
	'BRAZIL' = 'br',
	'BRITISH_INDIAN_OCEAN_TERRITORY' = 'io',
	'BRUNEI_DARUSSALAM' = 'bn',
	'BULGARIA' = 'bg',
	'BURKINA_FASO' = 'bf',
	'BURUNDI' = 'bi',
	'CAMBODIA' = 'kh',
	'CAMEROON' = 'cm',
	'CANADA' = 'ca',
	'CAPE_VERDE' = 'cv',
	'CAYMAN_ISLANDS' = 'ky',
	'CENTRAL_AFRICAN_REPUBLIC' = 'cf',
	'CHAD' = 'td',
	'CHILE' = 'cl',
	'CHINA' = 'cn',
	'CHRISTMAS_ISLAND' = 'cx',
	'COCOS_ISLANDS' = 'cc',
	'COLOMBIA' = 'co',
	'COMOROS' = 'km',
	'CONGO' = 'cg',
	'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' = 'cd',
	'COOK_ISLANDS' = 'ck',
	'COSTA_RICA' = 'cr',
	'CROATIA' = 'hr',
	'CUBA' = 'cu',
	'CURAÇAO' = 'cw',
	'CYPRUS' = 'cy',
	'CZECH_REPUBLIC' = 'cz',
	'CÔTE_DIVOIRE' = 'ci',
	'DENMARK' = 'dk',
	'DJIBOUTI' = 'dj',
	'DOMINICA' = 'dm',
	'DOMINICAN_REPUBLIC' = 'do',
	'EAST_TIMOR' = 'tl',
	'ECUADOR' = 'ec',
	'EGYPT' = 'eg',
	'EL_SALVADOR' = 'sv',
	'EQUATORIAL_GUINEA' = 'gq',
	'ERITREA' = 'er',
	'ESTONIA' = 'ee',
	'ETHIOPIA' = 'et',
	'FALKLAND_ISLANDS' = 'fk',
	'FAROE_ISLANDS' = 'fo',
	'FIJI' = 'fj',
	'FINLAND' = 'fi',
	'FRANCE' = 'fr',
	'FRENCH_GUIANA' = 'gf',
	'FRENCH_POLYNESIA' = 'pf',
	'FRENCH_SOUTHERN_TERRITORIES' = 'tf',
	'GABON' = 'ga',
	'GAMBIA' = 'gm',
	'Georgia' = 'ge',
	'GERMANY' = 'de',
	'GHANA' = 'gh',
	'GIBRALTAR' = 'gi',
	'GREECE' = 'gr',
	'GREENLAND' = 'gl',
	'GRENADA' = 'gd',
	'GUADELOUPE' = 'gp',
	'GUAM' = 'gu',
	'GUATEMALA' = 'gt',
	'GUERNSEY' = 'gg',
	'GUINEA' = 'gn',
	'GUINEA_BISSAU' = 'gw',
	'GUYANA' = 'gy',
	'HAITI' = 'ht',
	'HEARD_ISLAND_AND_MCDONALD_ISLANDS' = 'hm',
	'HONDURAS' = 'hn',
	'HONG_KONG' = 'hk',
	'Hungary' = 'hu',
	'ICELAND' = 'is',
	'INDIA' = 'in',
	'INDONESIA' = 'id',
	'IRAN' = 'ir',
	'IRAQ' = 'iq',
	'IRELAND' = 'ie',
	'ISLE_OF_MAN' = 'im',
	'ISRAEL' = 'il',
	'ITALY' = 'it',
	'JAMAICA' = 'jm',
	'JAPAN' = 'jp',
	'JERSEY' = 'je',
	'JORDAN' = 'jo',
	'KAZAKHSTAN' = 'kz',
	'KENYA' = 'ke',
	'KIRIBATI' = 'ki',
	'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' = 'kp',
	'KOREA_REPUBLIC_OF' = 'kr',
	'KOSOVO' = 'xk',
	'KUWAIT' = 'kw',
	'KYRGYZSTAN' = 'kg',
	'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' = 'la',
	'LATVIA' = 'lv',
	'LEBANON' = 'lb',
	'LESOTHO' = 'ls',
	'LIBERIA' = 'lr',
	'LIBYAN' = 'ly',
	'LIECHTENSTEIN' = 'li',
	'LITHUANIA' = 'lt',
	'LUXEMBOURG' = 'lu',
	'MACAO' = 'mo',
	'MADAGASCAR' = 'mg',
	'MALAWI' = 'mw',
	'MALAYSIA' = 'my',
	'MALDIVES' = 'mv',
	'MALI' = 'ml',
	'MALTA' = 'mt',
	'MARSHALL_ISLANDS' = 'mh',
	'MARTINIQUE' = 'mq',
	'MAURITANIA' = 'mr',
	'MAURITIUS' = 'mu',
	'MAYOTTE' = 'yt',
	'MEXICO' = 'mx',
	'MICRONESIA' = 'fm',
	'MOLDOVA_REPUBLIC_OF' = 'md',
	'MONACO' = 'mc',
	'MONGOLIA' = 'mn',
	'MONTENEGRO' = 'me',
	'MONTSERRAT' = 'ms',
	'MOROCCO' = 'ma',
	'MOZAMBIQUE' = 'mz',
	'MYANMAR' = 'mm',
	'NAMIBIA' = 'na',
	'NAURU' = 'nr',
	'NEPAL' = 'np',
	'NETHERLANDS' = 'nl',
	'NETHERLANDS_ANTILLES' = 'an',
	'NEW_CALEDONIA' = 'nc',
	'NEW_ZEALAND' = 'nz',
	'NICARAGUA' = 'ni',
	'NIGER' = 'ne',
	'NIGERIA' = 'ng',
	'NIUE' = 'nu',
	'NORFOLK_ISLAND' = 'nf',
	'NORTHERN_MARIANA_ISLANDS' = 'mp',
	'NORWAY' = 'no',
	'OMAN' = 'om',
	'PAKISTAN' = 'pk',
	'PALAU' = 'pw',
	'PALESTINIAN_TERRITORY_OCCUPIED' = 'ps',
	'PANAMA' = 'pa',
	'PAPUA_NEW_GUINEA' = 'pg',
	'PARAGUAY' = 'py',
	'PERU' = 'pe',
	'PHILIPPINES' = 'ph',
	'PITCAIRN' = 'pn',
	'POLAND' = 'pl',
	'PORTUGAL' = 'pt',
	'PUERTO_RICO' = 'pr',
	'QATAR' = 'qa',
	'ROMANIA' = 'ro',
	'RUSSIAN_FEDERATION' = 'ru',
	'RWANDA' = 'rw',
	'RÉUNION' = 're',
	'SAINT_BARTHÉLEMY_BL' = 'bl',
	'SAINT_HELENA' = 'sh',
	'SAINT_KITTS_AND_NEVIS' = 'kn',
	'SAINT_LUCIA' = 'lc',
	'SAINT_MARTIN_FRENCH_PART' = 'mf',
	'SAINT_PIERRE_AND_MIQUELON' = 'pm',
	'SAINT_VINCENT_AND_THE_GRENADINES' = 'vc',
	'SAMOA' = 'ws',
	'SAN_MARINO' = 'sm',
	'SAO_TOME_AND_PRINCIPE' = 'st',
	'SAUDI_ARABIA' = 'sa',
	'SENEGAL' = 'sn',
	'SERBIA' = 'rs',
	'SEYCHELLES' = 'sc',
	'SIERRA_LEONE' = 'sl',
	'SINGAPORE' = 'sg',
	'SINT_MAARTEN_DUTCH_PART' = 'sx',
	'SLOVAKIA' = 'sk',
	'SLOVENIA' = 'si',
	'SOLOMON_ISLANDS' = 'sb',
	'SOMALIA' = 'so',
	'SOUTH_AFRICA' = 'za',
	'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' = 'gs',
	'SOUTH_SUDAN' = 'ss',
	'SPAIN' = 'es',
	'SRI_LANKA' = 'lk',
	'SUDAN' = 'sd',
	'SURINAME' = 'sr',
	'SVALBARD_AND_JAN_MAYEN' = 'sj',
	'SWAZILAND' = 'sz',
	'SWEDEN' = 'se',
	'SWITZERLAND' = 'ch',
	'SYRIAN_ARAB_REPUBLIC' = 'sy',
	'TAIWAN' = 'tw',
	'TAJIKISTAN' = 'tj',
	'THAILAND' = 'th',
	'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' = 'mk',
	'TOGO' = 'tg',
	'TOKELAU' = 'tk',
	'TONGA' = 'to',
	'TRINIDAD_AND_TOBAGO' = 'tt',
	'TUNISIA' = 'tn',
	'TURKEY' = 'tr',
	'TURKMENISTAN' = 'tm',
	'TURKS_AND_CAICOS_ISLANDS' = 'tc',
	'TUVALU' = 'tv',
	'UGANDA' = 'ug',
	'UKRAINE' = 'ua',
	'UNITED_ARAB_EMIRATES' = 'ae',
	'UNITED_KINGDOM' = 'gb',
	'UNITED_REPUBLIC_OF_TANZANIA' = 'tz',
	'UNITED_STATES_MINOR_OUTLYING_ISLANDS' = 'um',
	'URUGUAY' = 'uy',
	'USA' = 'us',
	'UZBEKISTAN' = 'uz',
	'VANUATU' = 'vu',
	'VATICAN_CITY_STATE' = 'va',
	'VENEZUELA' = 've',
	'VIET_NAM' = 'vn',
	'VIRGIN_ISLANDS_GB' = 'vg',
	'VIRGIN_ISLANDS_USA' = 'vi',
	'WALLIS_AND_FUTUNA' = 'wf',
	'WESTERN_SAHARA' = 'eh',
	'YEMEN' = 'ye',
	'ZAMBIA' = 'zm',
	'ZIMBABWE' = 'zw'
}

export enum ProductStatus {
	'PENDING' = '0',
	'ACTIVE' = '1',
	'INACTIVE' = '2'
}

export enum SolidpayConfigPaymentType {
	'PA' = 'PA',
	'DB' = 'DB',
	'CD' = 'CD',
	'CP' = 'CP',
	'RV' = 'RV',
	'RF' = 'RF'
}

export enum DepositAmountType {
	'DEFAULT' = '0',
	'CUSTOMER_PROMOTION' = '1'
}

export enum NCIStatus {
	'NONE' = '0',
	'PENDING' = '1',
	'IN_PROCESS' = '2',
	'APPROVED' = '3',
	'REJECTED' = '4'
}

export enum CustomerSpecialStateStatus {
	'NEW' = '0',
	'IN_PROGRESS' = '1',
	'DONE' = '2',
	'CANCELED' = '3'
}

export enum FocalPaymentType {
	'FOCAL' = 'Focal Payment Provider'
}

export enum ForgetCustomerType {
	'FULL' = '1',
	'PARTIAL' = '2'
}

export enum BonusRequestStatus {
	'ON_HOLD' = '0',
	'DECLINED' = '1',
	'ACCEPTED' = '2',
	'PENDING_DEPOSIT' = '3'
}

export enum ReportingType {
	'Single' = '0',
	'Delegated' = '1',
	'DoubleDelegated' = '2'
}

export enum PayGatePaymentMethod {
	'CREDIT_CARD' = 'CC',
	'DEBIT_CARD' = 'DC',
	'EWALLET' = 'EW',
	'BANK_TRANSFER' = 'BT',
	'CASH_VOUCHER' = 'CV',
	'PREPAID_CARD' = 'PC'
}

export enum PoliticallyExposedPerson {
	'NOT_RELEVANT' = '0',
	'YES' = '1',
	'NO' = '2'
}

export enum ComplianceQuestion {
	'FATCA' = '20',
	'NET_WORTH' = '0',
	'GROSS_INCOME' = '1',
	'ANTICIPATED_TRADING_TURNOVER' = '2',
	'EMPLOYMENT_STATUS' = '3',
	'INDUSTRY' = '4',
	'SOURCE_OF_INCOME' = '6',
	'CFDS_TRADING_EXPERIENCE' = '7',
	'CFDS_TRADING_FREQUENCY' = '8',
	'CFDS_TRANSACTIONS_VOLUME' = '9',
	'FOREX_TRADING_EXPERIENCE' = '10',
	'FOREX_TRADING_FREQUENCY' = '11',
	'FOREX_TRANSACTIONS_VOLUME' = '12',
	'PREVIOUS_FINANCIAL_EXPERIENCE' = '13',
	'VERIFIED_POI' = '14',
	'VERIFIED_POR' = '15',
	'IID' = '16',
	'PASSPORT' = '17',
	'WORLD_CHECK_FULFILLED' = '18',
	'ASIC_TEST_STATUS' = '19',
	'EDUCATION_LEVEL' = '20',
	'STUDY_FIELD' = '21',
	'TERMS_AND_CONDITIONS' = '22'
}

export enum TradingTransactionsVolume {
	'UNKNOWN' = '0',
	'NONE' = '1',
	'LESS_25000' = '2',
	'BETWEEN_25000_TO_100000' = '3',
	'BETWEEN_100001_TO_250000' = '4',
	'OVER_250000' = '5'
}

export enum TransactionEndPointStatus {
	'PENDING' = '1',
	'PROCESSING' = '2',
	'DONE' = '3',
	'FAILED' = '4'
}

export enum VerificationSource {
	'REGISTRATION' = '1',
	'LOGIN' = '2',
	'UPDATE_PASSWORD' = '3'
}

export enum QuestionnaireAnswerDerivingStrategy {
	'HIDE' = '0',
	'SHOW' = '2'
}

export enum PersonalCategory_WithDeprecated {
	'UNKNOWN' = '0',
	'JUMPER' = '1',
	'LOW_POTENTIAL' = '2',
	'MEDIUM_POTENTIAL' = '3',
	'HOT_POTENTIAL' = '4'
}

export enum PersonalCategory_Deprecated {
	'JUMPER' = '1'
}

export enum PersonalCategory {
	'UNKNOWN' = '0',
	'LOW_POTENTIAL' = '2',
	'MEDIUM_POTENTIAL' = '3',
	'HOT_POTENTIAL' = '4'
}

export enum CustomerRelation {
	'NO_ANY_RELATIONS' = '0',
	'PARENT_WITH_CHILD' = '1',
	'CHILD' = '2'
}

export enum PayPalVerificationStatus {
	'UNVERIFIED' = '0',
	'VERIFIED' = '1'
}

export enum Direction {
	'NONE' = '0',
	'INCOMING' = '1',
	'OUTGOING' = '2'
}

export enum TaskStatus {
	'NEW' = '0',
	'IN_PROGRESS' = '1',
	'REJECTED' = '2',
	'FAILED' = '3',
	'RESOLVED' = '4',
	'CLOSED' = '5',
	'CANCELED' = '6'
}

export enum CustomerECDDPhone {
	'NOT_RELEVANT' = '0',
	'PHONE1' = '1',
	'PHONE2' = '2'
}

export enum UpdateEconomicProfileLogic {
	'NO_NEED_TO_SHOW_AML_QUESTIONNAIRE' = '0',
	'AML_QUESTIONNAIRE_IS_SHOWN_BUT_CAN_BE_POSTPONED_BY_CLIENT' = '1',
	'AML_QUESTIONNAIRE_IS_SHOWN_AND_IS_MANDATORY' = '2'
}

export enum AssignableEntitiesDispatcherStatus {
	'INACTIVE' = '0',
	'ACTIVE' = '1'
}

export enum BonusPromotion {
	'NOT_RELEVANT' = '0',
	'NORMAL' = '1',
	'POPULAR' = '2',
	'BIGGEST' = '3'
}

export enum TradingFrequency {
	'UNKNOWN' = '0',
	'NONE' = '5',
	'ZERO_TO_FIVE' = '1',
	'SIX_TO_TWENTY' = '2',
	'TWENTYONE_TO_FIFTY' = '3',
	'OVER_FIFTY' = '4'
}

export enum TradingAccountInstrumentType {
	'CFD' = '0',
	'SPREAD_BETTING' = '1',
	'QUANT_RANKS' = '2',
	'SHARE_DEALING' = '3',
	'ASSET_MANAGEMENT' = '4',
	'CRYPTO' = '5'
}

export enum PriorityTypes {
	'ID_NUMBER' = '0',
	'PASSPORT' = '1',
	'CONCAT' = '2',
	'TIN' = '3',
	'NCI' = '4',
	'LEI' = '5',
	'DRIVER_LICENSE' = '6'
}

export enum TTAClearingCode {
	'Default' = 'default',
	'Retail' = 'retail',
	'LAPI' = 'LAPI'
}

export enum DocumentStatus {
	'PENDING' = '0',
	'APPROVED' = '1',
	'REJECTED' = '2',
	'EXPIRED' = '4',
	'INPROCCESS' = '5',
	'PENDING_EXPIRATION' = '6'
}

export enum AutomaticTradingType {
	'NA' = '0',
	'TRADENCY' = '1',
	'CURRENSEE' = '2',
	'SIGNAL_TRADER' = '3',
	'FOREX_STRATEGY' = '4'
}

export enum WithdrawalRequestStatus {
	'NEW' = '1',
	'APPROVED' = '2',
	'COMPLETED' = '3',
	'REJECTED' = '4',
	'CANCELED' = '5',
	'FUNDS_REMOVED' = '6',
	'PENDING_FUNDS_REMOVAL' = '7',
	'PENDING_CANCELLATION' = '8'
}

export enum DialerType {
	'ASTERISK' = '1',
	'COPERATO' = '2',
	'API' = '3',
	'CLOUDTALK' = '4',
	'THREECX' = '5',
	'VOISO' = '6'
}

export enum TransactionEndPointGateway {
	'UNDEFINED' = '0',
	'SAFECHARGE' = '1',
	'LBN' = '2',
	'PSP_GATEWAY' = '3'
}

export enum Objective {
	'SALE_INTRODUCTION_CALL' = '0',
	'DEPOSIT' = '1',
	'COMPLETE_COMPLIANCE' = '3',
	'RETENTION' = '2'
}

export enum Industry {
	'NOT_RELEVANT' = '0',
	'ACCOUNTANCY' = '2',
	'ADMIN_SECRETARIAL' = '3',
	'AGRICULTURE' = '4',
	'FINANCIAL_SERVICES_BANKING' = '5',
	'CATERING_HOSPITALITY' = '6',
	'CREATIVE_MEDIA' = '7',
	'EDUCATION' = '8',
	'EMERGENCY_SERVICES' = '9',
	'ENGINEERING' = '10',
	'FINANCIAL_SERVICES_OTHER' = '11',
	'HEALTH_MEDICINE' = '12',
	'HM_FORCES' = '13',
	'hr' = '14',
	'FINANCIAL_SERVICES_INSURANCE' = '15',
	'it' = '16',
	'LEGAL' = '17',
	'LEISURE_ENTERTAINMENT_TOURISM' = '18',
	'MANUFACTURING' = '19',
	'MARKETING_PR_ADVERTISING' = '20',
	'PHARMACEUTICALS' = '21',
	'PROPERTY_CONSTRUCTIONS_TRADES' = '22',
	'RETAIL' = '23',
	'SALES' = '24',
	'SOCIAL_CARE_SERVICES' = '25',
	'TELECOMMUNICATIONS' = '26',
	'TRANSPORT_LOGISTICS' = '27',
	'OTHER' = '1'
}

export enum MarketingType {
	'AFFILIATE_ID' = '1',
	'PROMOTION_NAME' = '2'
}

export enum TransactionStatus {
	'PENDING' = '1',
	'PENDING_COMPLIANCE' = '2',
	'DONE' = '3',
	'FAILED' = '4',
	'REJECTED' = '5',
	'PENDING_PM_APPROVAL' = '6',
	'CANCELLED_PENDING_PM_APPROVAL' = '7',
	'CANCELLED_PENDING_COMPLIANCE' = '8'
}

export enum ComplianceSuspendedGround {
	'INACTIVITY' = '1',
	'INCOMPLETE_ECONOMIC_PROFILE' = '2',
	'EXPIRED_DOCUMENTATION' = '3',
	'INSUFFICIENT_FUNDS_SOURCE_INFORMATION' = '4',
	'INCOMPLETE_ECDD' = '5',
	'VULNERABLE_CLIENT_CONSUMER_DUTY' = '6',
	'SELF_EXCLUSION_REQUEST_CONSUMER_DUTY' = '7'
}

export enum CreditCardType {
	'UNKNOWN' = '0',
	'MASTER_CARD' = '1',
	'VISA' = '2',
	'DINERS' = '3',
	'AMERICAN_EXPRESS' = '4',
	'JCB' = '5',
	'DISCOVER' = '6',
	'LASERCARD' = '7',
	'MAESTRO' = '8',
	'SOLO' = '9',
	'SWITCH' = '10',
	'ENTROPAY' = '11',
	'DANKORT_VISA' = '12'
}

export enum RegistrationReason {
	'SPECULATIVE_TRADING' = '1',
	'INCOME_EARNING' = '2',
	'ASSETS_SAVING' = '3',
	'HEDGING' = '4',
	'OTHER' = '10'
}

export enum TradingExperienceAsset_WithDeprecated {
	'FOREX' = '0',
	'BINARY_OPTIONS' = '1',
	'BONDS' = '2',
	'SHARES' = '3',
	'STOCKS' = '4',
	'INDICES' = '5',
	'COMMODIES' = '6',
	'METALS' = '7',
	'MONEY_MANAGEMENT_SERVICE' = '8'
}

export enum TradingExperienceAsset_Deprecated {
	'SHARES' = '3'
}

export enum TradingExperienceAsset {
	'FOREX' = '0',
	'BINARY_OPTIONS' = '1',
	'BONDS' = '2',
	'STOCKS' = '4',
	'INDICES' = '5',
	'COMMODIES' = '6',
	'METALS' = '7',
	'MONEY_MANAGEMENT_SERVICE' = '8'
}

export enum OneClickClosingAccountStatusGround {
	'UNKNOWN' = '0',
	'WORLD_CHECK_MATCH' = '1',
	'FRAUD_4_DECLINED' = '2',
	'CLIENT_PREVIOUSLY_REJECTED_BLACKLISTED' = '3',
	'NO_VALID_POI_INABILITY_TO_VERIFY_IDENTITY' = '4',
	'NO_VALID_POR_INABILITY_TO_VERIFY_RESIDENCE' = '5',
	'APPROPRIATENESS_FAIL' = '6',
	'RESIDES_IN_A_BANNED_JURISDICTION' = '7',
	'ON_CLIENTS_REQUEST_4_DECLINED' = '8',
	'ABUSIVE_BEHAVIOUR' = '9',
	'ON_CLIENTS_REQUEST_4_TERMINATED' = '10',
	'FRAUD_4_TERMINATED' = '11',
	'INACTIVITY' = '12',
	'SUSPICIOUS_TRANSACTIONS_ACTIVITIES__AML_RELATED' = '13',
	'RESIDES_IN_A_JURISDICTION_SUBSEQUENTLY_BANNED' = '14',
	'WORLD_CHECK_MATCH_DURING_MONITORING' = '15',
	'MOKAS_REQUEST' = '16',
	'INABILITY_TO_CONTACT_CLIENTS_CLIENT_IS_NOT_COOPERATING' = '17',
	'UNDERAGE_CLIENT_4_DECLINED' = '18',
	'UNDERAGE_CLIENT_4_TERMINATED' = '19',
	'TERMINATED_BUSINESS' = '20',
	'DECLINED_BUSINESS' = '21',
	'ABUSIVE_BEHAVIOUR_DECLINED' = '22',
	'TERMINATED_REGULATORY_REASONS' = '23',
	'DECLINED_REGULATORY_REASONS' = '24',
	'DUPLICATE' = '25',
	'SPANISH_CLIENTS_APPROPRIATENESS_FAIL' = '26',
	'NEGATIVE_TARGET_ASSESSMENT' = '27',
	'VULNERABLE_CLIENT_CONSUMER_DUTY' = '28',
	'SELF_EXCLUSION_REQUEST_CONSUMER_DUTY' = '29',
	'VULNERABLE_CLIENT_CONSUMER_DUTY_DECLINED' = '30',
	'SELF_EXCLUSION_REQUEST_CONSUMER_DUTY_DECLINED' = '31',
	'INCOMPLETE_ECONOMIC_PROFILE' = '32',
	'SUSPICIOUS_KYC_DOCUMENTS' = '33',
	'INABILITY_TO_CONTACT_CLIENT_IS_NOT_COOPERATING' = '34',
	'GOVERNANCE_SCORE_FAILED' = '35',
	'SUSPICIOUS_KYC_DOCUMENTS_DECLINED' = '36'
}

export enum CustomerContactType {
	'DIRECTOR' = '0',
	'AUTHORISED_SIGNATORY' = '1',
	'BENEFICIAL_OWNER' = '2',
	'LAYERED_BENEFICIAL_OWNERSHIP' = '3',
	'US_PERSON' = '4',
	'CRS_CONTROLLING_PERSON' = '5',
	'FINANCE_CONTACT' = '6',
	'AUTHORISED_DIALER' = '7',
	'AUTHORISED_OPERATOR' = '8',
	'IT_EMERGENCY_CONTACT' = '9',
	'MT4_TECHNICAL_CONTACT' = '10',
	'TRADING_EMERGENCY_CONTACT' = '11',
	'SUPPORT_CONTACT' = '12',
	'CAN_APPROVE_INDIVIDUAL_DEALERS_OPERATORS' = '13'
}

export enum CustomerPotential {
	'UNKNOWN' = '0',
	'LOW' = '1',
	'MEDIUM' = '2',
	'HIGH' = '3',
	'ABUSER' = '10',
	'PROFESSIONAL' = '11'
}

export enum ConfidentialEntityPropertyUIPlacement {
	'UNKNOWN' = '0',
	'CUSTOMER_FORM' = '1',
	'AUDIT_GRID_OLD_VALUE' = '2',
	'AUDIT_GRID_CURRENT_VALUE' = '3',
	'CALL_TASK_GRID' = '4',
	'CI_GRID' = '5',
	'CALL_TASK_FORM' = '6',
	'JMX' = '7',
	'AUDIT_FORM_OLD_VALUE' = '8',
	'AUDIT_FORM_CURRENT_VALUE' = '9',
	'CUSTOMER_DOCUMENT_FORM' = '10',
	'CUSTOMER_CONTACT' = '11'
}

export enum TBAValidationType {
	'COMPLIANCE_VALIDATION' = '1',
	'AVAILABLE_BALANCE_FOR_REMOVAL_VALIDATION' = '2',
	'UNUSED_MARGIN_VALIDATION' = '3',
	'UNTRADED_BONUSES_CONFIRMATION' = '4'
}

export enum RebateProgram {
	'ACTIVE_TRADER' = '1',
	'AT1' = '2',
	'AT2' = '3',
	'AT3' = '4',
	'AT4' = '5'
}

export enum PanelItemType {
	'DEFAULT' = '0',
	'DEPARTMENT' = '1'
}

export enum DeactivationSource {
	'UNDEFINED' = '0',
	'AES' = '1',
	'WEBSITE' = '2'
}

export enum DepositRiskGroup {
	'UNKNOWN' = '0',
	'LOW' = '1',
	'MEDIUM' = '2',
	'HIGH' = '3'
}

export enum StudyField {
	'UNKNOWN' = '0',
	'ACCOUNTING' = '2',
	'AGRICULTURE' = '3',
	'ARCHITECTURE' = '4',
	'BANKING' = '5',
	'BUSINESS_ADMIN' = '6',
	'ECONOMICS' = '7',
	'ENGINEERING' = '8',
	'FINANCE' = '9',
	'HOSPITALITY_TOURISM' = '10',
	'HR' = '11',
	'IT' = '12',
	'LAW' = '13',
	'LINGUISTICS' = '14',
	'LOGISTICS' = '15',
	'MATHEMATICS' = '16',
	'MEDIA' = '17',
	'MEDICINE' = '18',
	'NATURAL_SCIENCES' = '19',
	'PHARMACEUTICALS' = '20',
	'PSYCHOLOGY' = '21',
	'SOCIAL_SCIENCES' = '22',
	'OTHER' = '1'
}

export enum TradingExperienceScf {
	'UNKNOWN' = '0',
	'NONE' = '1',
	'ONE_TO_SIX' = '2',
	'SIX_TO_TWELVE' = '3',
	'OVER_TWELVE' = '4'
}

export enum CustomerEngagementState {
	'PRE_ENGAGED' = '0',
	'ENGAGED' = '1',
	'NOT_ENGAGED' = '2',
	'TRASHED' = '3',
	'PRE_LEAD' = '4',
	'PENDING_LEAD' = '5'
}

export enum UserEmailType {
	'DEFAULT_SUPPORT' = '0',
	'USER_EMAIL' = '1',
	'PREFIX_EMAIL' = '2'
}

export enum WorldCheckValidationPoint {
	'MANUAL' = '0',
	'FULL_REGISTRATION' = '1',
	'DEPOSIT' = '2'
}

export enum PendingBonusType {
	'RETENTION' = '1',
	'SAS' = '2'
}

export enum TradingAccountMode {
	'FULL' = '0',
	'READ_ONLY' = '1',
	'LONG_ONLY' = '2',
	'SHORT_ONLY' = '3',
	'NO' = '4'
}

export enum ScoreType {
	'APPROPRIATENESS_SCORE' = '0',
	'GOVERNANCE_SCORE' = '1'
}

export enum NetWorth {
	'UNKNOWN' = '0',
	'BELOW_100000' = '1',
	'BETWEEN_100001_TO_250000' = '2',
	'BETWEEN_250001_TO_1000000' = '3',
	'OVER_1000000' = '4'
}

export enum ProductConfiguration {
	'REGULAR' = '0',
	'AVAILABLE_UNDER_OTHER_REGULATION' = '1',
	'REQUIRES_NEW_QUESTIONNAIRE' = '2',
	'BETTER_CONDITIONS' = '3'
}

export enum ReferralSource {
	'UNKNOWN' = '0',
	'INTERNET' = '1',
	'FRIEND' = '2',
	'COLLEGUE' = '3',
	'TV_ADS' = '4',
	'PRINTED_ADS' = '5',
	'EXHIBITION' = '7',
	'OTHER' = '6'
}

export enum VIPLevel {
	'BASIC' = '0',
	'CLASSIC' = '1',
	'PREMIUM' = '2',
	'ULTIMATE' = '3',
	'MICRO' = '4',
	'SILVER' = '5',
	'GOLD' = '6',
	'PLATINUM' = '7',
	'EXCLUSIVE' = '8'
}

export enum ServiceType {
	'SUBSCRIPTION' = '1',
	'SERVICE' = '2',
	'MARKETING_EMAILS' = '3'
}

export enum ActionType {
	'READ' = 'R',
	'WRITE' = 'W',
	'CREATE' = 'C',
	'DELETE' = 'D'
}

export enum DispatcherType {
	'POOL' = '2',
	'ROUTER' = '1'
}

export enum EndPointType {
	'ENVOY_ENDPOINT' = 'envoy_endpoint',
	'WALLET_ENDPOINT' = 'wallet_endpoint',
	'WEBMONEY_ENDPOINT' = 'wm_endpoint',
	'LIBERTY_RESERVE_ENDPOINT' = 'lr_endpoint',
	'MANUAL_ENDPOINT' = 'manual_endpoint',
	'BANK_ACCOUNT_ENDPOINT' = 'ba_endpoint',
	'COMPANY_ENDPOINT' = 'company_endpoint',
	'REGULAR_CREDIT_CARD_ENDPOINT' = 'regular_cc_endpoint',
	'VOID_CREDIT_CARD_ENDPOINT' = 'void_cc_endpoint',
	'REFUND_CREDIT_CARD_ENDPOINT' = 'refund_cc_endpoint',
	'TRADING_ACCOUNT_ENDPOINT' = 'ta_endpoint',
	'NETELLER_ENDPOINT' = 'neteller_endpoint',
	'MONEYBOOKERS_ENDPOINT' = 'moneybookers_endpoint',
	'QIWI_ENDPOINT' = 'qiwi_endpoint',
	'SC_WEBMONEY_ENDPOINT' = 'webmoney_endpoint',
	'CHINAUNION_ENDPOINT' = 'chinaunion__endpoint',
	'LOBANET_ENDPOINT' = 'lobanet_endpoint',
	'CUP_ENDPOINT' = 'cup_endpoint',
	'PSP_ENDPOINT' = 'psp_endpoint',
	'BAOFOO_ENDPOINT' = 'baofoo_endpoint',
	'SOLIDPAY_ENDPOINT' = 'solidpay_endpoint',
	'FOCAL_ENDPOINT' = 'focal_endpoint',
	'PAYGATE_ENDPOINT' = 'paygate_endpoint',
	'PAYMENT_ASIA_ENDPOINT' = 'payment_asia_endpoint',
	'CRYPTO_ENDPOINT' = 'crypto_endpoint',
	'MD_APM_ENDPOINT' = 'md_apm_endpoint'
}

export enum VipOfferGroup {
	'EDUCATION' = '1',
	'SPECIAL_EVENTS' = '2',
	'SERVICES' = '3'
}

export enum AppSourceType {
	'COSMOS_WEB' = '1',
	'COSMOS_MOBILE_I_O_S' = '2',
	'COSMOS_MOBILE_ANDROID' = '3',
	'COSMOS_TABLET_I_O_S' = '4',
	'COSMOS_TABLET_ANDROID' = '5',
	'COSMOS_DESKTOP_WINDOWS' = '6',
	'COSMOS_MOBILE_WINDOWS' = '7',
	'INDIGO_WEB' = '8',
	'INDIGO_MOBILE_I_O_S' = '9',
	'INDIGO_MOBILE_ANDROID' = '10',
	'INDIGO_TABLET_I_O_S' = '11',
	'INDIGO_TABLET_ANDROID' = '12',
	'WRAPPER_MOBILE_IOS' = '13',
	'WRAPPER_MOBILE_ANDROID' = '14',
	'WRAPPER_TABLET_IOS' = '15',
	'WRAPPER_TABLET_ANDROID' = '16',
	'COSMOS_MOBILE_HUAWEI' = '17',
	'COSMOS_TABLET_HUAWEI' = '18'
}

export enum SolidpayConfigPaymentMethod {
	'WORLD' = 'WORLD',
	'VPAY' = 'VPAY',
	'VISAELECTRON' = 'VISAELECTRON',
	'VISADEBIT' = 'VISADEBIT',
	'VISA' = 'VISA',
	'TARJETASHOPPING' = 'TARJETASHOPPING',
	'SERVIRED' = 'SERVIRED',
	'NATIVA' = 'NATIVA',
	'NARANJA' = 'NARANJA',
	'MERCADOLIVRE' = 'MERCADOLIVRE',
	'MASTERDEBIT' = 'MASTERDEBIT',
	'MASTER' = 'MASTER',
	'MAESTRO' = 'MAESTRO',
	'JCB' = 'JCB',
	'HIPERCARD' = 'HIPERCARD',
	'ELO' = 'ELO',
	'DISCOVER' = 'DISCOVER',
	'DINERS' = 'DINERS',
	'DANKORT' = 'DANKORT',
	'CENCOSUD' = 'CENCOSUD',
	'CARTEBLEUE' = 'CARTEBLEUE',
	'CARTEBANCAIRE' = 'CARTEBANCAIRE',
	'CABAL' = 'CABAL',
	'BCMC' = 'BCMC',
	'ARGENCARD' = 'ARGENCARD',
	'APPLEPAY' = 'APPLEPAY',
	'AMEX' = 'AMEX',
	'YANDEX' = 'YANDEX',
	'TRUSTLY' = 'TRUSTLY',
	'TENPAY' = 'TENPAY',
	'SIBS_MULTIBANCO' = 'SIBS_MULTIBANCO',
	'SHETAB' = 'SHETAB',
	'RATENKAUF' = 'RATENKAUF',
	'QIWI' = 'QIWI',
	'PRZELEWY' = 'PRZELEWY',
	'PF_KARTE_DIRECT' = 'PF_KARTE_DIRECT',
	'PAYTRAIL' = 'PAYTRAIL',
	'PAYSAFECARD' = 'PAYSAFECARD',
	'PAYPAL' = 'PAYPAL',
	'PAYOLUTION_INVOICE' = 'PAYOLUTION_INVOICE',
	'PAYOLUTION_INS' = 'PAYOLUTION_INS',
	'PAYOLUTION_ELV' = 'PAYOLUTION_ELV',
	'PAYDIREKT' = 'PAYDIREKT',
	'PAYBOX' = 'PAYBOX',
	'ONECARD' = 'ONECARD',
	'MONEYSAFE' = 'MONEYSAFE',
	'MONEYBOOKERS' = 'MONEYBOOKERS',
	'MBWAY' = 'MBWAY',
	'MASTERPASS' = 'MASTERPASS',
	'KLARNA_PAYMENTS_SLICEIT' = 'KLARNA_PAYMENTS_SLICEIT',
	'KLARNA_PAYMENTS_PAYLATER' = 'KLARNA_PAYMENTS_PAYLATER',
	'IKANOOI_SE' = 'IKANOOI_SE',
	'DAOPAY' = 'DAOPAY',
	'CHINAUNIONPAY' = 'CHINAUNIONPAY',
	'CASHU' = 'CASHU',
	'ASTROPAY_STREAMLINE_OT' = 'ASTROPAY_STREAMLINE_OT',
	'ASTROPAY_STREAMLINE_CASH' = 'ASTROPAY_STREAMLINE_CASH',
	'ALIPAY' = 'ALIPAY',
	'AFTERPAY' = 'AFTERPAY',
	'TRUSTPAY_VA' = 'TRUSTPAY_VA',
	'SOFORTUEBERWEISUNG' = 'SOFORTUEBERWEISUNG',
	'SADAD' = 'SADAD',
	'PREPAYMENT' = 'PREPAYMENT',
	'POLI' = 'POLI',
	'OXXO' = 'OXXO',
	'INTERAC_ONLINE' = 'INTERAC_ONLINE',
	'IDEAL' = 'IDEAL',
	'GIROPAY' = 'GIROPAY',
	'EPS' = 'EPS',
	'ENTERCASH' = 'ENTERCASH',
	'DIRECTDEBIT_SEPA' = 'DIRECTDEBIT_SEPA',
	'BOLETO' = 'BOLETO',
	'BITCOIN' = 'BITCOIN'
}

export enum CustomerRegistrationLevel {
	'PARTIAL' = '0',
	'MANDATORY' = '1',
	'REGULATED' = '2'
}

export enum AMLScoreConfigValue {
	'NA' = '0',
	'HighLow' = '1',
	'HighMedium' = '2',
	'HighHigh' = '3'
}

export enum CustomerContactStatus {
	'ACTIVE' = '0',
	'INACTIVE' = '1'
}

export enum MarketingEmailStatus {
	'ALLOWED' = '0',
	'DISALLOWED' = '1'
}

export enum RejectionReason {
	'REJECTED_BY_COMPANY' = '1',
	'REJECTED_BY_USER' = '2',
	'BELOW_ALLOWED_MINIMUM_AMOUNT' = '3',
	'PASSED_ALLOWED_TOTAL_AMOUNT' = '4',
	'PASSED_ALLOWED_DEPOSIT_COUNT' = '5',
	'PASSED_ALLOWED_CC_DEPOSIT_COUNT' = '6',
	'CREDIT_CARD_STATUS_NOT_APPROVED' = '7',
	'PASSED_ALLOWED_TOTAL_DEPOSIT_AMOUNT_GRACE_PERIOD' = '8'
}

export enum CustomerSpecialStateType {
	'VULNERABILITY' = '0',
	'COOLDOWN' = '1'
}

export enum OneClickClosingAccountStatus {
	'OPEN' = '1',
	'DECLINED' = '2',
	'TERMINATED' = '3'
}

export enum PayGatePaymentType {
	'PAYGATE' = 'PayGate Payment Provider'
}

export enum UserStatus {
	'ACTIVE' = '1',
	'INACTIVE' = '2'
}

export enum CompensationFactorType {
	'NONE' = '0',
	'FIXED' = '1',
	'PERCENTAGE' = '2'
}

export enum SubscriptionStatus {
	'ACTIVE' = '1',
	'PENDING' = '2',
	'INACTIVE' = '3'
}

export enum GracePeriodStatus {
	'GP_NONE' = '0',
	'GP_ENTERED' = '1',
	'GP_REMINDER_SENT' = '2',
	'GP_TASK_CREATED' = '3',
	'GP_EXIT_SUCCESS' = '4',
	'GP_EXIT_UNSUCCESSFUL' = '5'
}

export enum NatureOfTransactions {
	'SHORT_TERM_INVESTMENT' = '1',
	'LONG_TERM_INVESTMENT' = '2',
	'OTHER' = '10'
}

export enum TradingFrequencyScf {
	'UNKNOWN' = '0',
	'NONE' = '1',
	'ONE_TO_FIVE' = '2',
	'SIX_TO_TWENTY' = '3',
	'TWENTYONE_TO_FIFTY' = '4',
	'OVER_FIFTY' = '5'
}

export enum ClientClassification {
	'RETAIL' = '0',
	'ELECTIVE_PROFESSIONAL' = '1',
	'PROFESSIONAL' = '2',
	'ELIGIBLE_COUNTER_PARTY' = '3',
	'TECH_WHITELABEL' = '4'
}

export enum UserType {
	'USER' = '0',
	'SERVICE' = '1'
}

export enum PaymentAsiaPaymentType {
	'PAYMENT_ASIA' = 'Payment Asia Payment Provider'
}

export enum RouteGroup {
	'GROUP1' = '1',
	'GROUP2' = '2',
	'GROUP3' = '3',
	'GROUP4' = '4',
	'GROUP5' = '5'
}

export enum QuestionnaireQuestionValidator {
	'NOT_SPECIFIED' = '0',
	'BIRTHDAY' = '1',
	'TIN' = '3',
	'NOT_USER_COUNTY' = '4',
	'NCI' = '5',
	'TIN2' = '6'
}

export enum ConfirmationStatus {
	'PENDING' = '0',
	'CONFIRM' = '1',
	'REJECT' = '2'
}

export enum PreferredDepositMethod {
	'CREDIT_CARD' = '1',
	'WIRE_TRANSFER' = '2',
	'ENVOY' = '3'
}

export enum TradingGoal {
	'UNKNOWN' = '0',
	'MAKE_MONEY' = '1',
	'DAY_TRADING' = '2',
	'BI' = '3',
	'LEARN_TRADING' = '4',
	'OTHER' = '5'
}

export enum TotalDepositPotential_WithDeprecated {
	'UNKNOWN' = '0',
	'TDP_0_100' = '1',
	'TDP_101_500' = '2',
	'TDP_501_1000' = '3',
	'TDP_1001_5000' = '4',
	'TDP_5001_10000' = '5',
	'TDP_10001_20000' = '6',
	'TDP_20001_50000' = '7',
	'TDP_50001_100000' = '8',
	'TDP_100001_500000' = '9',
	'TDP_OVER_500000' = '10',
	'CANNOT_DETERMINE' = '11',
	'NO_POTENTIAL' = '12',
	'TDP_100_1000' = '13',
	'TDP_1001_5000_NEW' = '14',
	'TDP_5001_20000' = '15',
	'TDP_20001_100000' = '16',
	'TDP_OVER_100000' = '17'
}

export enum TotalDepositPotential_Deprecated {
	'UNKNOWN' = '0',
	'TDP_0_100' = '1',
	'TDP_101_500' = '2',
	'TDP_501_1000' = '3',
	'TDP_1001_5000' = '4',
	'TDP_5001_10000' = '5',
	'TDP_10001_20000' = '6',
	'TDP_20001_50000' = '7',
	'TDP_50001_100000' = '8',
	'TDP_100001_500000' = '9',
	'TDP_OVER_500000' = '10'
}

export enum TotalDepositPotential {
	'CANNOT_DETERMINE' = '11',
	'NO_POTENTIAL' = '12',
	'TDP_100_1000' = '13',
	'TDP_1001_5000_NEW' = '14',
	'TDP_5001_20000' = '15',
	'TDP_20001_100000' = '16',
	'TDP_OVER_100000' = '17'
}

export enum BrandBrokerStatus {
	'INACTIVE' = '0',
	'ACTIVE' = '1'
}

export enum CounterpartEntityType {
	'UNKNOWN' = '0',
	'ORGANIZATION' = '1',
	'INDIVIDUAL' = '2'
}

export enum QuestionnaireStaticQuestionValidator {
	'NOT_SPECIFIED' = '0',
	'NAME' = '1',
	'BIRTHDAY' = '2',
	'ADDRESS' = '3',
	'CITY' = '4',
	'ZIP_CODE' = '5'
}

export enum CustomerWorldCheckStatus {
	'PENDING' = '0',
	'NO_MATCH' = '1',
	'MATCHED' = '2',
	'FAILED' = '3',
	'POSITIVE' = '4'
}

export enum ApprovalStatus {
	'PENDING' = '0',
	'IN_PROGRESS' = '1',
	'REJECTED' = '2',
	'APPROVED' = '3'
}

export enum SasUserRole {
	'Brand_based' = 'Brand_based',
	'Pool_based' = 'Pool_based',
	'Assigned_user_based' = 'Assigned_user_based',
	'Company_based' = 'Company_based'
}

export enum WithdrawalValidationType {
	'PENDING_DEPOSITS_VALIDATION' = '1',
	'COMPLIANCE_VALIDATION' = '2',
	'AVAILABLE_FOR_WITHDRAWAL_AMOUNT' = '3',
	'UNUSED_MARGIN_VALIDATION' = '4',
	'UNTRADED_BONUSES_CONFIRMATION' = '5',
	'PROFIT_REFUND_VALIDATION' = '6'
}

export enum OnlineStatus {
	'OFFLINE' = '0',
	'ONLINE' = '1'
}

export enum SaxoTemplateType {
	'COUNTERPART_TEMPLATE' = '0',
	'ACCOUNT_TEMPLATE' = '1'
}

export enum SystemErrorSeverity {
	'WARN' = 'warn',
	'ERROR' = 'error',
	'FATAL' = 'fatal'
}

export enum TradingAccountType {
	'REAL' = '0',
	'DEMO' = '1'
}

export enum CreditLineStatus {
	'NEW' = '1',
	'PENDING' = '2',
	'DONE' = '3',
	'FAILED' = '4'
}

export enum TransactionType {
	'DEPOSIT' = '1',
	'WITHDRAWAL' = '2',
	'CORRECTION' = '3'
}

export enum AScoreLevel {
	'LOW' = '0',
	'MEDIUM' = '1',
	'HIGH' = '2'
}

export enum SolidPayPaymentType {
	'SOLIDPAY' = 'SolidPay Payment Provider'
}

export enum CustomerAccountType {
	'INDIVIDUALS' = '1',
	'INDIVIDUALS_HIGH_RISK' = '2',
	'INDIVIDUAL_PARTNER' = '19',
	'INDIVIDUAL_CLIENT' = '20',
	'INDIVIDUAL_LAPI' = '21',
	'CORPORATE_COMPANY_WITH_ORDINARY_SHARES' = '3',
	'CORPORATE_PARTNER' = '22',
	'CORPORATE_CLIENT' = '23',
	'CORPORATE_LAPI' = '17',
	'CORPORATE_LISTED_COMPANY' = '4',
	'CORPORATE_LICENSED_COMPANY' = '5',
	'CORPORATE_COMPANY_WITH_BEARER_SHARES' = '6',
	'CORPORATE_PARTNERSHIP' = '7',
	'CORPORATE_TRUST' = '8',
	'CORPORATE_FUNDS' = '9',
	'CORPORATE_OTHER' = '10',
	'DEALER_ACCOUNT' = '25',
	'JOINT_ACCOUNT' = '11',
	'MANAGED_AC' = '12',
	'INSTITUTIONAL_CLIENTS' = '13',
	'HEDGING_COUNTERPARTY' = '15',
	'CLEARING_ACCOUNT' = '16',
	'OFFSET_ACCOUNT' = '18',
	'OMNIBUS_PARTNER' = '24',
	'MAM_AC' = '26',
	'PROFESSIONAL_CORPORATE' = '28',
	'PROFESSIONAL_INDIVIDUAL' = '27',
	'PROFESSIONAL_INDIVIDUAL_SPREADBET' = '29',
	'RETAIL_CORPORATE' = '30',
	'CORPORATE_DATA_SALES_PARTNER' = '31',
	'CORPORATE_DATA_DISTRIBUTION_PARTNER' = '32',
	'OTHER' = '14'
}

export enum MethodType {
	'OTHER' = '1',
	'CREDIT_CARD' = '2',
	'PAY_PAL' = '3',
	'MONEY_BOOKERS' = '4',
	'NET_TELLER' = '5',
	'CLICK_AND_BUY' = '6',
	'CASH' = '7',
	'LIBERTY_RESERVE' = '8',
	'E_BULLION' = '9',
	'E_GOLD' = '10',
	'CHECK' = '11',
	'NETELIS' = '12',
	'ENVOY' = '13',
	'WEBMONEY' = '14',
	'WIRE_TRANSFER' = '15',
	'CHINA_UNION_PAY' = '16',
	'LOBANET' = '17',
	'QIWI' = '18',
	'PD_SOLUTIONS_DEPOSIT' = '19',
	'YUU_PAY' = '20',
	'PSP' = '21',
	'CUP' = '22',
	'QIWI_WITHDRAWAL' = '23',
	'MANUAL' = '24',
	'BAOFOO' = '25',
	'SOLIDPAY' = '26',
	'FOCAL' = '27',
	'PAYGATE' = '28',
	'FAST_BANK_TRANSFER' = '29',
	'IDEAL' = '30',
	'SOFORT' = '31',
	'PAYMENT_ASIA' = '32',
	'GLOBEPAY' = '33',
	'TRUSTLY' = '34',
	'PRZELEWY24' = '35',
	'SEA_SOLUTION' = '36',
	'CRYPTO' = '78',
	'ALTCRYPTO' = '75',
	'UPI' = '64',
	'MPESA' = '74',
	'HELP_2_PAY' = '103',
	'WOWS_PAY' = '104',
	'EEIZE_PAY' = '106',
	'ZOTA_PAY' = '42',
	'ASTRO_PAY' = '85',
	'HAPPY_PAY' = '101',
	'BITOLO' = '117'
}

export enum BonusPaymentType {
	'CASH' = '1',
	'PENDING' = '2',
	'REAL_MONEY' = '3'
}

export enum GrossIncome {
	'UNKNOWN' = '0',
	'LESS_THAN_25000' = '1',
	'BETWEEN_25001_TO_100000' = '2',
	'BETWEEN_100001_TO_250000' = '3',
	'OVER_250000' = '4'
}

export enum TradingExperienceCompany {
	'FXCM' = '0',
	'SAXOBANK' = '1',
	'ALPARI' = '2',
	'IG_GROUP' = '3',
	'ONANDA' = '4',
	'GAIN_FOREX_COM' = '5',
	'GFT' = '6',
	'FXPRO' = '7',
	'FOREX_CLUB' = '8',
	'FXDD' = '9',
	'CITY_INDEX_FX_SOLUTIONS' = '10',
	'INTERACTIVE_BROKERS' = '11',
	'FXOPEN' = '12',
	'CMC' = '13',
	'DUKASCOPY' = '14',
	'ETORO' = '15',
	'PLUS500' = '16',
	'UNKNOWN' = '17'
}

export enum EnvoyPaymentType {
	'WEBMONEY' = 'webmoney',
	'CASHU' = 'cashu',
	'TELEINGRESO' = 'teleingreso',
	'TODITOCARD' = 'toditocard',
	'TICKETSURF' = 'ticketsurf',
	'USEMYBANK' = 'usemybank',
	'SPOROPAY' = 'sporopay',
	'NEOSURF' = 'neosurf',
	'LOBANET' = 'lobanet',
	'MISTERCASH' = 'mistercash',
	'INSTADEBIT' = 'instadebit',
	'GLUEPAY' = 'gluepay',
	'GIROPAY' = 'giropay',
	'EUTELLER' = 'euteller',
	'EPS' = 'eps',
	'EPAY' = 'epay',
	'DINEROMAIL' = 'dineromail',
	'CACHU' = 'cachu',
	'BANKAXESS' = 'bankaxess',
	'ABAQOOS' = 'abaqoos',
	'IDEALGC' = 'idealgc',
	'IDEAL' = 'ideal',
	'POLI' = 'poli',
	'POLIGB' = 'poligb',
	'POLINZ' = 'polinz',
	'BANKLINK' = 'banklink',
	'BANKLINKSWED' = 'banklinkswed',
	'BOLETO' = 'boleto',
	'EKONTO' = 'ekonto',
	'EWIRESE' = 'ewirese',
	'EWIRENO' = 'ewireno',
	'EWIREDK' = 'ewiredk',
	'MULTIBANCO' = 'multibanco',
	'PRZELEWY' = 'przelewy',
	'PRZELEWY24' = 'przelewy24',
	'MONETA' = 'moneta',
	'SOFORTUEBERWEISUNG' = 'sofortueberweisung',
	'BANKTRANSFER' = 'banktransfer',
	'MONEYBOOKERS' = 'moneybookers',
	'ASTROPAYCARD' = 'astropaycard',
	'KIWI' = 'Kiwi'
}

export enum CCDocumentRejectionReasonBack {
	'NOT_SIGNED' = '0',
	'SIGNED_ON_A_STICKER' = '1',
	'NOT_SIGNED_ON_THE_PROPER_PLACE' = '2',
	'LOW_QUALITY' = '3',
	'LOOKS_SUSPICIOUS' = '4',
	'OTHER' = '5'
}

export enum CustomerQuestionnaireStatus {
	'ACTIVE' = '0',
	'PENDING_EXPIRATION' = '1',
	'EXPIRED' = '2'
}

export enum TitleTransfer_WithDeprecated {
	'Undefined' = '0',
	'None' = '1',
	'FullEquity' = '2',
	'MarginOnly' = '3'
}

export enum TitleTransfer_Deprecated {
	'Undefined' = '0'
}

export enum TitleTransfer {
	'None' = '1',
	'FullEquity' = '2',
	'MarginOnly' = '3'
}

export enum BonusRequestType {
	'MANUAL_BONUS' = '0',
	'PENDING_BONUS' = '1',
	'AUTOMATIC_BONUS' = '2',
	'COMPLIANCE_BONUS' = '3',
	'INSTANT_COMPLIANCE_BONUS' = '4',
	'ELIGIBLE_COMPLIANCE_BONUS' = '5',
	'SAS_PENDING_BONUS' = '6',
	'VERIFIED_ID_BONUS' = '7',
	'VERIFIED_RESIDENCE_BONUS' = '8',
	'FULL_REGISTRATION_BONUS' = '9',
	'COMPLETE_VERIFICATION_BONUS' = '10',
	'DEPOSIT_BONUS' = '11',
	'FIRST_DEPOSIT_BONUS' = '12',
	'EXTRA_FIRST_DEPOSIT_BONUS' = '13',
	'QUIZ_ASIC_BONUS' = '14',
	'WEB_TO_MOBILE_BONUS' = '15',
	'CUSTOMER_LEVEL_FIRST_DEPOSIT_BONUS' = '16',
	'FULL_REGISTRATION_CASH_BONUS' = '17'
}

export enum TradingExperiencePeriod {
	'UNKNOWN' = '0',
	'NONE' = '1',
	'WEEKS' = '2',
	'MONTHS' = '3',
	'YEARS' = '4'
}

export enum UserRole {
	'HEAD_OF_SUPPORT' = '1',
	'CUSTOMER_SERVICE_DIVISION_MANAGER' = '2',
	'COMPLIANCE_DEPARTMENT' = '3',
	'FINANCE_DEPARTMENT' = '4',
	'TRADING_SPECIALIST' = '5',
	'CHIEF_TRADING_SPECIALIST' = '6',
	'TRAINING_MANAGER' = '7',
	'HEAD_OF_SALES' = '8',
	'HEAD_OF_OPERATIONS' = '9',
	'DESK_HEAD' = '10',
	'BUSINESS_DEVELOPMENT_MANAGER' = '11',
	'ADMINISTRATIVE_MANAGER' = '12',
	'ACCOUNT_MANAGER' = '13',
	'CUSTOMER_SUPPORT_REPRESENTATIVE' = '14',
	'CUSTOMER_SUPPORT_MANAGER' = '15',
	'HEAD_OF_PRE_RETENTION_DEPARTMENT' = '16',
	'ACCOUNT_ASSISTANT' = '17',
	'RELATIONS_MANAGER' = '18',
	'ACCOUNT_REPRESENTATIVE' = '19',
	'ASSOCIATE_CLIENT_RELATIONSHIP_OFFICER' = '20'
}

export enum AnticipatedTradingTurnover {
	'UNKNOWN' = '0',
	'LESS_THAN_100000' = '1',
	'BETWEEN_100000_TO_250000' = '2',
	'BETWEEN_250001_TO_1000000' = '3',
	'OVER_1000000' = '4'
}

export enum ComplianceStage {
	'NON_COMPLIANT' = '0',
	'COMPLIANT' = '1',
	'PENDING_COMPLIANCE' = '2',
	'LIMITED_COMPLIED' = '3',
	'COMPLIANCE_REVOKED' = '4',
	'COMPLIANCE_SUSPENDED' = '5'
}

export enum VipOfferType {
	'CHECKBOX' = '1',
	'FREE_TEXT' = '2',
	'LIST' = '3'
}

export enum QuestionnaireQuestionType {
	'NONE' = '0',
	'LABEL' = '1',
	'EDIT_TEXT' = '2',
	'EDIT_TEXT_AREA' = '3',
	'LIST' = '4',
	'CHECKBOX' = '5',
	'MULTI_CHECKBOX' = '6',
	'RADIO' = '7',
	'HORIZONTAL_RADIO' = '8',
	'DATE' = '9',
	'DATETIME' = '10',
	'PHONE' = '11',
	'EMAIL' = '12',
	'COUNTRY' = '13',
	'PASSWORD' = '14',
	'CURRENCY' = '15',
	'MULTISELECT_ALL' = '16',
	'MULTISELECT_NONE' = '17',
	'MULTISELECT_ALL_NONE' = '18',
	'ALLOWED_COUNTRIES' = '19'
}

export enum ECDDOption {
	'FIRST_DEPOSIT_FROM_EEA_OR_EQUIVALENT' = '0',
	'PHONE_VERIFICATION' = '1',
	'REGISTERED_POST' = '2',
	'CONFIRMATION_LETTER' = '3',
	'VIDEO_CALL' = '4',
	'ELECTRONIC_VERIFICATION' = '5'
}

export enum TermsConditionsNewVersion {
	'PENDING' = '0',
	'ACCEPTED' = '1',
	'DECLINED' = '2',
	'POSTPONED' = '3',
	'NOT_RELEVANT' = '4'
}

export enum TransactionReasonName {
	'ADDITIONAL_BONUS' = 'Additional Bonus',
	'ADDITIONAL_BONUS_FOR_FIRST_DEPOSIT' = 'Additional Bonus for first deposit',
	'BALANCING_ACCOUNT_TO_ZERO' = 'Balancing account to Zero',
	'BONUS_REMOVAL' = 'Bonus Removal',
	'CANCEL_WITHDRAWAL_BONUS' = 'Cancel withdrawal bonus',
	'CANCELLATION_TRANSACTION' = 'Cancellation Transaction',
	'CC_WITHDRAWAL' = 'CC withdrawal',
	'CC_WITHDRAWAL_CANCELLED_PENDING_DEPOSIT' = 'CC withdrawal cancelled pending deposit',
	'CHARGE_BACK' = 'Charge Back',
	'CHARGE_BACK_CANCELLATION' = 'Charge Back cancellation',
	'CHARGE_BACK_FOLLOWING_WITHDRAWAL' = 'charge back following withdrawal',
	'COMMISSION' = 'Commission',
	'COMPENSATION' = 'Compensation',
	'DEALING_ERROR' = 'Dealing Error',
	'DEPOSIT_FEE' = 'Deposit Fee',
	'EXPIRATION' = 'Expiration',
	'ELIGIBLE_COMPLIANCE' = 'Eligible Compliance',
	'FEE_REIMBURSEMENT' = 'Fee reimbursement',
	'FINANCE_ERROR' = 'Finance Error',
	'FIRST_DEPOSIT_BONUS' = 'First Deposit Bonus',
	'EXTRA_FIRST_DEPOSIT_BONUS' = 'Extra First Deposit Bonus',
	'DEPOSIT_BONUS' = 'Deposit Bonus',
	'FRAUD_ADJUSTMENT' = 'Fraud adjustment',
	'FRAUD_ADJUSTMENT_REVERSAL' = 'Fraud adjustment reversal',
	'FREE_MONEY' = 'Free Money',
	'FREE_MONEY_AWOL' = 'Free money AWOL',
	'FUND_TRANSFER_BETWEEN_CUSTOMERS' = 'Fund transfer between customers',
	'FUNDS_TRANSFER_BETWEEN_CUSTOMERS' = 'Funds Transfer between customers',
	'INTEREST_WAS_NOT_TRIGERRED_ON_A_NON_ISLAMIC_ACCOUNT' = 'Interest was not trigerred on a non-Islamic account',
	'INTEREST_WAS_TRIGGERED_ON_AN_ISLAMIC_ACCOUNT' = 'Interest was triggered on an Islamic account',
	'LOBANET' = 'Lobanet',
	'MANUAL_DEPOSIT_DUE_TO_WITHDRAWAL_THAT_WAS_BOUNCED_BACK' = 'Manual Deposit due to Withdrawal that was bounced back',
	'MONEY_MANAGER_COMMISSION' = 'Money Manager Commission',
	'NEGATIVE_PL_ADJUSTMENT' = 'Negative P/L Adjustment',
	'NEGATIVE_PL_ADJUSTMENT_CHB' = 'Negative P/L adjustment - CHB',
	'OTHER' = 'Other',
	'CASH_DEPOSIT' = 'Cash deposit',
	'PARTNER_BONUS' = 'Partner Bonus',
	'PARTNER_PAYMENT' = 'Partner payment',
	'PARTNER_PAYMENT_REMOVAL' = 'Partner payment removal',
	'PHONE_CC_DEPOSIT' = 'Phone CC deposit',
	'POSITIVE_PL_ADJUSTMENT' = 'Positive P/L adjustment',
	'POSITIVE_PL_ADJUSTMENT_CHB' = 'Positive P/L adjustment - CHB',
	'REBATE' = 'Rebate',
	'REFER_A_FRIEND' = 'Refer A Friend',
	'REGULAR_CC_DEPOSIT' = 'Regular CC deposit',
	'REGULAR_ENVOY_DEPOSIT' = 'Regular Envoy deposit',
	'REGULAR_ENVOY_WITHDRAWAL' = 'Regular Envoy withdrawal',
	'REGULAR_CHINAUNION_WITHDRAWAL' = 'Regular Chaina Union withdrawal',
	'REGULAR_LIBERTY_RESERVE_DEPOSIT' = 'Regular Liberty reserve deposit',
	'REGULAR_LIBERTY_RESERVE_WITHDRAWAL' = 'Regular Liberty reserve withdrawal',
	'REGULAR_WEBMONEY_WITHDRAWAL' = 'Regular Webmoney withdrawal',
	'REVERSE_MC' = 'Reverse MC',
	'ROLLOVER_CHARGE' = 'Rollover charge',
	'SAS' = 'SAS',
	'INTEREST' = 'Interest',
	'SPREAD_REBATE' = 'Spread Rebate',
	'SYSTEM_FEE' = 'System Fee',
	'SYSTEM_FEE_REMOVAL' = 'System Fee Removal',
	'SHARES_DIVIDEND' = 'Shares Dividend',
	'SHARES_SPLIT' = 'Shares Split',
	'SLIPPAGE' = 'Slippage',
	'SPECIAL_PROMOTION' = 'Special Promotion',
	'SPIKE' = 'Spike',
	'TECHNICAL_FAILURE' = 'Technical Failure',
	'TEMP_DEPOSIT' = 'Temp Deposit',
	'TEMP_DEPOSIT_REMOVAL' = 'Temp Deposit removal',
	'TOPUP_BONUS' = 'TopUp Bonus',
	'TRANSFER_FROM_A_DIFFERENT_CUSTOMER' = 'Transfer from a different customer',
	'TRANSFER_INTO_ACCOUNT' = 'Transfer into account',
	'TRANSFER_OUT_OF_AN_ACCOUNT' = 'Transfer out of an account',
	'WIRE_DEPOSIT' = 'wire deposit',
	'WIRE_WITHDRAWAL' = 'wire withdrawal',
	'WITHDRAWAL_RETURN_REVERSAL' = 'withdrawal return reversal',
	'WITHDRAWAL_REVERSAL' = 'withdrawal reversal',
	'QIWI_WITHDRAWAL' = 'Qiwi withdrawal',
	'NETELLER_DEPOSIT' = 'Neteller deposit',
	'MONEYBOOKERS_DEPOSIT' = 'Moneybookers deposit',
	'QIWI_DEPOSIT' = 'Qiwi deposit',
	'WEBMONEY_DEPOSIT' = 'WebMoney deposit',
	'CHINA_UNION_PAY_DEPOSIT' = 'China Union Pay deposit',
	'LOBANET_DEPOSIT' = 'Lobanet deposit',
	'FAST_BANK_TRANSFER_DEPOSIT' = 'Fast Bank Transfer deposit',
	'BOLETO_DEPOSIT' = 'BOLETO deposit',
	'IDEAL_DEPOSIT' = 'iDeal deposit',
	'INSTANT_COMPLIANCE' = 'Instant Compliance',
	'QUIZ_ASIC_BONUS' = 'Quiz Asic Bonus',
	'GIROPAY_DEPOSIT' = 'Giropay deposit',
	'SOFORT_DEPOSIT' = 'Sofort deposit',
	'CASHU_DEPOSIT' = 'cashU deposit',
	'INSTANT_BANK_DEPOSIT' = 'Instant Bank deposit',
	'BALANCING_ACCOUNT_TO_ZERO_DUE_TO_A_MIGRATION' = 'Balancing account to zero due to a migration',
	'TRANSFER_OUT_OF_AN_ACCOUNT_DUE_TO_MIGRATION' = 'Transfer out of an account due to migration',
	'TRANSFER_INTO_AN_ACCOUNT_DUE_TO_MIGRATION' = 'Transfer into an account due to migration',
	'REMOVAL_DUE_TO_WITHDRAW' = 'Bonus removal due to withdraw',
	'BONUS_WAS_REMOVED_DUE_TO_COMPLETION' = 'Bonus was removed due to completion',
	'LOST_OF_BONUS_DUE_TO_NEGATIVE_PL' = 'Lost of bonus due to negative P/L',
	'PAYPAL_DEPOSIT' = 'PayPal deposit',
	'SAS_INACTIVITY_FEE' = 'Inactivity fee',
	'CRM' = 'CRM',
	'DEALING' = 'DEALING-BAZero',
	'DEPOSIT_BA_ZERO' = 'DEPOSIT-BAZero',
	'DEPOSIT_FAILURE' = 'Deposit failure',
	'BONUS_REMOVAL_DUE_TO_AUTOWITHDRAWAL' = 'Bonus removal due to autowithdrawal',
	'CANCELLATION_NEGATIVE_BONUS_ADJUSTMENT' = 'Cancellation negative bonus adjustment',
	'ACCOUNT_CLOSE_OUT_FEE' = 'Account close out fee',
	'PAYPAL_MANUAL_WITHDRAWAL' = 'PayPal',
	'WITHDRAWAL_CORRECTION' = 'Withdrawal correction',
	'INACTIVITY_SYSTEM_FEE' = 'Inactivity system fee',
	'INACTIVITY_SYSTEM_FEE_REVERSAL' = 'Inactivity system fee reversal',
	'ASTROPAY_PRE_PAID_DEPOSIT' = 'AstropayPrePaid deposit',
	'MONEYIN_DEPOSIT' = 'Moneyin deposit',
	'PAYGATE_CREDIT_CARD_DEPOSIT' = 'CC Paygate Deposit',
	'PAYGATE_BANK_TRANSFER_DEPOSIT' = 'SID Paygate Deposit',
	'SOLIDPAY_DEPOSIT' = 'SolidPay Deposit',
	'SAS_INACTIVITY_FEE_REMOVAL' = 'Inactivity fee removal',
	'TRUSTLY' = 'Trustly',
	'PRAXIS_DEPOSIT' = 'Praxis Deposit',
	'BONUS_REMOVAL_DUE_TO_TRANFER_OUT_OF_THE_ACCOUNT' = 'Bonus removal due to transfer out of the account',
	'EASY_EFT' = 'EasyEFT',
	'PRAXIS_CREDIT_CARD_DEPOSIT' = 'CC Praxis Deposit',
	'PRAXIS_APM_DEPOSIT' = 'APM Praxis Deposit',
	'PRAXIS_NETELLER_DEPOSIT' = 'Neteller Praxis Deposit',
	'PRAXIS_SKRILL_DEPOSIT' = 'Skrill Praxis Deposit',
	'MD_CASHIER_DEPOSIT' = 'MD Cashier Deposit',
	'MD_CASHIER_CREDIT_CARD_DEPOSIT' = 'CC MD Cashier Deposit',
	'MD_CASHIER_APM_DEPOSIT' = 'APM MD Cashier Deposit',
	'SAFECHARGE14_DEPOSIT' = 'Safecharge 1.4 Deposit',
	'SAFECHARGE14_CREDIT_CARD_DEPOSIT' = 'CC Safecharge 1.4 Deposit',
	'SAFECHARGE14_APM_DEPOSIT' = 'APM Safecharge 1.4 Deposit',
	'BRIDGERPAY_DEPOSIT' = 'Bridgerpay Deposit',
	'BRIDGERPAY_CREDIT_CARD_DEPOSIT' = 'CC Bridgerpay Deposit',
	'BRIDGERPAY_APM_DEPOSIT' = 'APM Bridgerpay Deposit',
	'BONUS_REMOVAL_DUE_TO_MAXIMUM_CUP' = 'Bonus removal due to maximum cup',
	'BONUS_LOST_DUE_TO_LIQUIDATION' = 'Bonus lost due to liquidation',
	'BONUS_EXPIRED' = 'Bonus Expired'
}

export enum TransactionKind {
	'NEGATIVE_ADJUSTMENT' = 'neg_adj',
	'NEGATIVE_DEALING_CORRECTION' = 'neg_deal_cor',
	'NEGATIVE_FRAUD_ADJUSTMENT' = 'neg_fraud_adj',
	'NEGATIVE_BONUS_ADJUSTMENT' = 'neg_bonus_adj',
	'CLOSING_ACCOUNT_BOOK_NEGATIVE' = 'closing_account_book_neg',
	'PARTNER_NEGATIVE_ADJUSTMENT' = 'partner_neg_adj',
	'POSITIVE_ADJUSTMENT' = 'pos_adj',
	'POSITIVE_DEALING_CORRECTION' = 'pos_deal_cor',
	'POSITIVE_FRAUD_ADJUSTMENT' = 'pos_fraud_adj',
	'POSITIVE_BONUS_ADJUSTMENT' = 'pos_bonus_adj',
	'CLOSING_ACCOUNT_BOOK_POSITIVE' = 'closing_account_book_pos',
	'PARTNER_PAYMENT' = 'partner_payment',
	'PARTNER_BONUS' = 'partner_bonus',
	'BONUS' = 'bonus',
	'CREDIT_CARD_DEPOSIT' = 'cc_deposit',
	'WIRE_TRANSFER_DEPOSIT' = 'wt_deposit',
	'CREDIT_CREDIT_CARD_WITHDRAWAL' = 'credit_cc_withdrawal',
	'VOID_CREDIT_CARD_WITHDRAWAL' = 'void_cc_withdrawal',
	'REFUND_CREDIT_CARD_WITHDRAWAL' = 'refund_cc_withdrawal',
	'WIRE_TRANSFER_WITHDRAWAL' = 'wt_withdrawal',
	'MANUAL_DEPOSIT' = 'manual_deposit',
	'INTERNAL_DEPOSIT' = 'internal_deposit',
	'MANUAL_WITHDRAWAL' = 'manual_withdrawal',
	'INTERNAL_WITHDRAWAL' = 'internal_withdrawal',
	'LIBERTY_RESERVE_DEPOSIT' = 'lr_deposit',
	'LIBERTY_RESERVE_WITHDRAWAL' = 'lr_withdrawal',
	'ENVOY_DEPOSIT' = 'envoy_deposit',
	'ENVOY_WITHDRAWAL' = 'envoy_withdrawal',
	'WM_WITHDRAWAL' = 'wm_withdrawal',
	'NETELLER_DEPOSIT' = 'neteller_deposit',
	'MONEYBOOKERS_DEPOSIT' = 'moneybookers_deposit',
	'QIWI_DEPOSIT' = 'qiwi_deposit',
	'WEBMONEY_DEPOSIT' = 'webmoney_deposit',
	'CHINAUNION_DEPOSIT' = 'chinaunion_deposit',
	'CUP_DEPOSIT' = 'cup_deposit',
	'CHINAUNION_WITHDRAWAL' = 'chinaunion_withdrawal',
	'LOBANET_DEPOSIT' = 'lobanet_deposit',
	'QIWI_WITHDRAWAL' = 'qiwi_withdrawal',
	'PSP_DEPOSIT' = 'psp_deposit',
	'BAOFOO_DEPOSIT' = 'baofoo_cup_deposit',
	'SOLIDPAY_DEPOSIT' = 'solidpay_deposit',
	'FOCAL_DEPOSIT' = 'focal_deposit',
	'PAYGATE_DEPOSIT' = 'paygate_deposit',
	'PAYMENT_ASIA_DEPOSIT' = 'payment_asia_deposit',
	'CRYPTO_WITHDRAWAL' = 'crypto_withdrawal',
	'MD_APM_WITHDRAWAL' = 'md_apm_withdrawal'
}

export enum ForbiddenJurisdictionType {
	'BLOCKED' = '0',
	'ALLOWED' = '1'
}

export enum SecurityQuestion {
	'MOTHERS_MAIDEN_NAME' = '1',
	'FAVORITE_TEACHERS_NAME' = '2',
	'FAVORITE_TV_PROGRAM' = '3',
	'FAVORITE_COLOR' = '4',
	'FAVORITE_SPORTS_TEAM_NAME' = '5',
	'PETS_NAME' = '6'
}

export enum BonusTaskRecordStatus {
	'FAILED' = '0',
	'FINISHED' = '1'
}

export enum ProcessingType {
	'MANUAL' = '0',
	'AUTO' = '1'
}

export enum TokenType {
	'EMAIL1_VERIFICATION' = '1',
	'EMAIL2_VERIFICATION' = '2',
	'PASSWORD' = '3',
	'SUBSCRIPTION' = '4'
}

export enum TradingTransactionsVolumeScf {
	'UNKNOWN' = '0',
	'NONE' = '1',
	'LESS_5000' = '2',
	'BETWEEN_5001_AND_50000' = '3',
	'BETWEEN_50001_AND_150000' = '4',
	'OVER_150000' = '5'
}

export enum PostVerificationStatus {
	'NA' = '0',
	'NOT_APPLICABLE' = '1',
	'PENDING' = '2',
	'IN_PROGRESS' = '3',
	'VERIFIED' = '4',
	'REJECTED' = '5'
}

export enum TransactionProcessingType {
	'ADJUSTMENT_BASED' = '0',
	'DEPOSIT_BASED' = '1'
}

export enum FatcaReportable {
	'YES' = '1',
	'NO' = '0'
}

export enum PostRejectionReason {
	'NA' = '0',
	'CORPORATE_ACCOUNT' = '1',
	'THE_3RD_PARTY_DEPOSIT' = '2',
	'CLOSED_ACCOUNT' = '3',
	'OTHER' = '4'
}

export enum TBARequestStatus {
	'NEW' = '1',
	'COMPLETED' = '2',
	'PENDING_FUNDS_REMOVAL' = '3',
	'PENDING_BALANCE_UPDATE' = '4',
	'FUNDS_REMOVED' = '5',
	'REJECTED' = '6',
	'FAILED' = '7'
}

export enum EducationLevel {
	'UNKNOWN' = '0',
	'NO_EDUCATION' = '1',
	'PROFESSIONAL_QUALIFICATION' = '2',
	'DOCTOR_OR_EQUIVALENT' = '3',
	'MASTER_OR_EQUIVALENT' = '4',
	'BACHELOR_OR_EQUIVALENT' = '5',
	'UPPER_SECONDARY_EDUCATION' = '6',
	'LOWER_SECONDARY_EDUCATION' = '7',
	'PRIMARY_EDUCATION' = '8'
}

export enum TradingExperienceInstrument_WithDeprecated {
	'CURRENCIES' = '0',
	'METALS' = '1',
	'COMMODITIES' = '2',
	'INDICES' = '3',
	'SHARES' = '4',
	'BONDS' = '5',
	'OPTIONS' = '6',
	'EURUSD' = '7',
	'GBPUSD' = '8',
	'GOLDUSD' = '9',
	'DJ30USD' = '10',
	'CRUDEOILUSD' = '11',
	'EURJPY' = '12',
	'USDJPY' = '13',
	'GBPJPY' = '14',
	'AUDUSD' = '15',
	'USDCAD' = '16',
	'USDCHF' = '17',
	'DAX30EUR' = '18',
	'SILVERUSD' = '19',
	'EURCHF' = '20',
	'EURGBP' = '21',
	'NZDUSD' = '22',
	'AUDJPY' = '23',
	'CAC40EUR' = '24',
	'GBPCHF' = '25',
	'NASDAQ100USD' = '26',
	'GBPAUD' = '27',
	'FTSEMIBINDEXEUR' = '28',
	'IBEX35INDEXEUR' = '29',
	'FTSE100GBP' = '30',
	'SNP500USD' = '31',
	'EURAUD' = '32',
	'APPLEINCUSD' = '33',
	'EURCAD' = '34',
	'CHFJPY' = '35',
	'WHEATUSD' = '36',
	'CORNUSD' = '37'
}

export enum TradingExperienceInstrument_Deprecated {
	'CURRENCIES' = '0',
	'METALS' = '1',
	'COMMODITIES' = '2',
	'INDICES' = '3',
	'SHARES' = '4',
	'BONDS' = '5',
	'OPTIONS' = '6'
}

export enum TradingExperienceInstrument {
	'EURUSD' = '7',
	'GBPUSD' = '8',
	'GOLDUSD' = '9',
	'DJ30USD' = '10',
	'CRUDEOILUSD' = '11',
	'EURJPY' = '12',
	'USDJPY' = '13',
	'GBPJPY' = '14',
	'AUDUSD' = '15',
	'USDCAD' = '16',
	'USDCHF' = '17',
	'DAX30EUR' = '18',
	'SILVERUSD' = '19',
	'EURCHF' = '20',
	'EURGBP' = '21',
	'NZDUSD' = '22',
	'AUDJPY' = '23',
	'CAC40EUR' = '24',
	'GBPCHF' = '25',
	'NASDAQ100USD' = '26',
	'GBPAUD' = '27',
	'FTSEMIBINDEXEUR' = '28',
	'IBEX35INDEXEUR' = '29',
	'FTSE100GBP' = '30',
	'SNP500USD' = '31',
	'EURAUD' = '32',
	'APPLEINCUSD' = '33',
	'EURCAD' = '34',
	'CHFJPY' = '35',
	'WHEATUSD' = '36',
	'CORNUSD' = '37'
}

export enum CreditCardStatus {
	'PENDING' = '1',
	'APPROVED' = '2',
	'REJECTED' = '3',
	'BLACK_LISTED' = '4',
	'REVOKE_PENDING' = '5'
}

export enum GBGValidationPoint {
	'DEPOSIT' = '0',
	'PASSED_QUIZ' = '1',
	'FULL_REGISTRATION' = '2'
}

export enum CUPPaymentType {
	'CUP' = 'ChainaUnionPay-LBN'
}

export enum GBGStatus {
	'UN_CHECKED' = '0',
	'PASSED' = '1',
	'REFER' = '2',
	'ALERT' = '3'
}

export enum TradingExperience {
	'UNKNOWN' = '0',
	'NONE' = '1',
	'ONE_TO_THREE' = '2',
	'FOUR_TO_SEVEN' = '3',
	'OVER_EIGHT' = '4'
}

export enum QuestionnaireStaticQuestionType {
	'NONE' = '0',
	'EDIT_TEXT' = '1',
	'EMAIL' = '2',
	'PASSWORD' = '3',
	'PHONE' = '4',
	'DATE' = '5',
	'COUNTRY' = '6',
	'CITIZENSHIP' = '7',
	'LANGUAGE' = '8',
	'CHECKBOX' = '9'
}

export enum CCDocumentRejectionReasonFront {
	'LAST_4_DIGITS_COVERED' = '0',
	'DOE_COVERED' = '1',
	'LOW_QUALITY' = '2',
	'ADDITIONAL_INFO_UNDER_THE_NAMES' = '3',
	'LOOKS_SUSPICIOUS' = '4',
	'THIRD_PARTY_NAME' = '5',
	'OTHER' = '6'
}

export enum EndpointProcessingType {
	'NONE' = '0',
	'MANUAL' = '1',
	'WITHDRAWAL_REQUEST' = '2'
}

export enum RegistrationSource {
	'REGULAR' = '0',
	'GOOGLE_ONE_TAP' = '1',
	'GOOGLE_CONNECT' = '2',
	'FACEBOOK_CONNECT' = '3',
	'APPLE_SIGN_IN' = '4',
	'HUAWEI' = '5'
}

export enum TradingAccountStatus {
	'INACTIVE' = '0',
	'ACTIVE' = '1',
	'CLOSED' = '3',
	'PENDING' = '4',
	'ARCHIVED' = '5'
}

export enum BaoFooPaymentType {
	'BAOFOO' = 'ChainaUnionPay-BaoFoo'
}

export enum QuestionnaireQuestionDerivingStrategy {
	'HIDE' = '0',
	'DISABLE' = '1',
	'SHOW' = '2'
}

export enum CustomerRegistrationStatus {
	'LEAD' = '0',
	'DEMO' = '1',
	'REAL' = '2',
	'REAL_FUNDED' = '4'
}

export enum TINAbsenceReason {
	'NOT_RELEVANT' = '0',
	'DOES_NOT_ISSUE' = '1',
	'UNABLE_TO_OBTAIN' = '2',
	'NOT_REQUIRED' = '3',
	'NOT_TAXABLE_PERSON' = '4',
	'PERSON_RECENTLY_MOVED' = '5'
}

export enum MaliciousScanStatus {
	'NOT_SCANNED' = '0',
	'PENDING' = '1',
	'APPROVED' = '2',
	'INFECTED' = '3',
	'SCAN_ERROR' = '4',
	'SCAN_OLD_ERROR' = '5'
}

export enum MigrationConfirmationStatus {
	'NOT_RELEVANT' = '0',
	'YES' = '1',
	'NO' = '2',
	'PENDING' = '3'
}

export enum Priority {
	'HIGH' = '0',
	'MEDIUM' = '1',
	'LOW' = '2'
}

export enum RegulationStatus {
	'DISABLED' = '0',
	'ENABLED' = '1'
}

export enum ValueFormatter {
	'AMOUNT' = 'AMOUNT',
	'AUTH3D' = 'AUTH3D',
	'DATE' = 'DATE',
	'ENTITY_LINK' = 'ENTITY_LINK',
	'ENUM' = 'ENUM',
	'ENUM_CITIZENSHIP' = 'ENUM_CITIZENSHIP',
	'MONEY' = 'MONEY',
	'NUMBER' = 'NUMBER',
	'RELATED_ENTITY' = 'RELATED_ENTITY'
}

export enum ValueRenderer {
	'BONUS_REQUEST_BUTTON' = 'BONUS_REQUEST_BUTTON',
	'BOOLEAN' = 'BOOLEAN',
	'BOOLEAN_COMPLETED' = 'BOOLEAN_COMPLETED',
	'BRAND' = 'BRAND',
	'CLIENT_STATUS' = 'CLIENT_STATUS',
	'COMMUNICATION_BUTTONS' = 'COMMUNICATION_BUTTONS',
	'CONFIDENTIAL' = 'CONFIDENTIAL',
	'COUNTRY' = 'COUNTRY',
	'CREDIT_CARD_TYPE' = 'CREDIT_CARD_TYPE',
	'DOCUMENT_BUTTONS' = 'DOCUMENT_BUTTONS',
	'LEI' = 'LEI',
	'PROFILE_REVIEW_BUTTONS' = 'PROFILE_REVIEW_BUTTONS',
	'QUESTIONNAIRE_CRITERIA_REVIEW_BUTTONS' = 'QUESTIONNAIRE_CRITERIA_REVIEW_BUTTONS',
	'QUESTIONNAIRE_DEFAULT_BUTTONS' = 'QUESTIONNAIRE_DEFAULT_BUTTONS'
}

export enum FilterType {
	'Number' = 'number',
	'String' = 'string',
	'Date' = 'date',
	'Enum' = 'enum',
	'Boolean' = 'boolean',
	'Entity' = 'entity',
	'EntitySearch' = 'entitySearch',
	'UserSearch' = 'userSearch'
}
export const ENUMS_MAP : { [key: string]: any }  = {
	"com.tradefxl.commons.enums.TradePlatformType_WithDeprecated" : TradePlatformType_WithDeprecated,
	"com.tradefxl.commons.enums.TradePlatformType_Deprecated" : TradePlatformType_Deprecated,
	"com.tradefxl.commons.enums.TradePlatformType" : TradePlatformType,
	"com.tradefxl.crm.api.enums.TradingEligibilityTestStatusType" : TradingEligibilityTestStatusType,
	"com.tradefxl.commons.enums.PoolType" : PoolType,
	"com.tradefxl.crm.api.enums.AlertName" : AlertName,
	"com.tradefxl.ci.commons.CIType" : CIType,
	"com.tradefxl.ci.commons.CISource" : CISource,
	"com.tradefxl.commons.enums.Medium" : Medium,
	"com.tradefxl.commons.enums.RunningEnvironment" : RunningEnvironment,
	"com.tradefxl.commons.enums.Language" : Language,
	"com.tradefxl.crm.api.enums.AlertType" : AlertType,
	"com.tradefxl.commons.enums.PaymentMethodsType" : PaymentMethodsType,
	"com.tradefxl.crm.api.enums.SourceSystem" : SourceSystem,
	"com.tradefxl.crm.api.enums.AlertStage" : AlertStage,
	"com.tradefxl.commons.enums.MaritalStatus" : MaritalStatus,
	"com.tradefxl.commons.enums.NonEngagedType" : NonEngagedType,
	"com.tradefxl.commons.enums.Gender" : Gender,
	"com.tradefxl.commons.enums.PaymentProcessorsType" : PaymentProcessorsType,
	"com.tradefxl.commons.enums.VerificationStatus" : VerificationStatus,
	"com.tradefxl.commons.enums.Currency" : Currency,
	"com.tradefxl.commons.enums.ContactAvailableMethod" : ContactAvailableMethod,
	"com.tradefxl.commons.search.criteria.LogicalOperator" : LogicalOperator,
	"com.tradefxl.commons.enums.TradePlatformAdvancedType_WithDeprecated" : TradePlatformAdvancedType_WithDeprecated,
	"com.tradefxl.commons.enums.TradePlatformAdvancedType_Deprecated" : TradePlatformAdvancedType_Deprecated,
	"com.tradefxl.commons.enums.TradePlatformAdvancedType" : TradePlatformAdvancedType,
	"com.tradefxl.commons.enums.CashierType" : CashierType,
	"com.tradefxl.commons.enums.Country" : Country,
	"com.tradefxl.commons.enums.PhoneType" : PhoneType,
	"com.tradefxl.commons.enums.NonEngagedAndTrash" : NonEngagedAndTrash,
	"com.tradefxl.commons.enums.EmailValidationStatus" : EmailValidationStatus,
	"com.tradefxl.commons.enums.State" : State,
	"com.tradefxl.commons.enums.ApplicationType" : ApplicationType,
	"com.tradefxl.crm.api.enums.ChinaUnionPaymentType" : ChinaUnionPaymentType,
	"com.tradefxl.crm.api.enums.customer.AntiMoneyLaundryClassificationStatus" : AntiMoneyLaundryClassificationStatus,
	"com.tradefxl.crm.api.entities.finance.status.PaymentAccountStatus" : PaymentAccountStatus,
	"com.tradefxl.crm.api.enums.customer.QuestionnaireType" : QuestionnaireType,
	"com.tradefxl.crm.api.enums.customer.IncomeSource" : IncomeSource,
	"com.tradefxl.crm.api.enums.customer.CustomerDocumentType" : CustomerDocumentType,
	"com.tradefxl.crm.api.enums.customer.SourceOfIncome" : SourceOfIncome,
	"com.tradefxl.crm.api.enums.PoolMemberType" : PoolMemberType,
	"com.tradefxl.crm.api.enums.customer.CustomerEntityTypes" : CustomerEntityTypes,
	"com.tradefxl.crm.api.enums.customer.PendingComplianceGround" : PendingComplianceGround,
	"com.tradefxl.crm.api.enums.FirstDepositPotential" : FirstDepositPotential,
	"com.tradefxl.crm.api.enums.customer.TaxJurisdiction" : TaxJurisdiction,
	"com.tradefxl.crm.api.enums.ProductStatus" : ProductStatus,
	"com.tradefxl.crm.api.enums.SolidpayConfigPaymentType" : SolidpayConfigPaymentType,
	"com.tradefxl.crm.api.entities.finance.DepositAmountType" : DepositAmountType,
	"com.tradefxl.crm.api.enums.customer.NCIStatus" : NCIStatus,
	"com.tradefxl.crm.api.enums.CustomerSpecialStateStatus" : CustomerSpecialStateStatus,
	"com.tradefxl.crm.api.enums.FocalPaymentType" : FocalPaymentType,
	"com.tradefxl.crm.api.entities.customer.gdpr.ForgetCustomerType" : ForgetCustomerType,
	"com.tradefxl.crm.api.enums.BonusRequestStatus" : BonusRequestStatus,
	"com.tradefxl.crm.api.enums.ReportingType" : ReportingType,
	"com.tradefxl.crm.api.enums.PayGatePaymentMethod" : PayGatePaymentMethod,
	"com.tradefxl.crm.api.enums.customer.PoliticallyExposedPerson" : PoliticallyExposedPerson,
	"com.tradefxl.crm.api.enums.customer.ComplianceQuestion" : ComplianceQuestion,
	"com.tradefxl.crm.api.enums.customer.TradingTransactionsVolume" : TradingTransactionsVolume,
	"com.tradefxl.crm.api.entities.finance.TransactionEndPointStatus" : TransactionEndPointStatus,
	"com.tradefxl.crm.api.enums.customer.verification.VerificationSource" : VerificationSource,
	"com.tradefxl.crm.api.enums.customer.QuestionnaireAnswerDerivingStrategy" : QuestionnaireAnswerDerivingStrategy,
	"com.tradefxl.crm.api.enums.PersonalCategory_WithDeprecated" : PersonalCategory_WithDeprecated,
	"com.tradefxl.crm.api.enums.PersonalCategory_Deprecated" : PersonalCategory_Deprecated,
	"com.tradefxl.crm.api.enums.PersonalCategory" : PersonalCategory,
	"com.tradefxl.crm.api.enums.customer.CustomerRelation" : CustomerRelation,
	"com.tradefxl.crm.api.entities.finance.PayPalVerificationStatus" : PayPalVerificationStatus,
	"com.tradefxl.crm.api.enums.Direction" : Direction,
	"com.tradefxl.crm.api.enums.TaskStatus" : TaskStatus,
	"com.tradefxl.crm.api.enums.customer.CustomerECDDPhone" : CustomerECDDPhone,
	"com.tradefxl.crm.api.enums.UpdateEconomicProfileLogic" : UpdateEconomicProfileLogic,
	"com.tradefxl.crm.api.enums.AssignableEntitiesDispatcherStatus" : AssignableEntitiesDispatcherStatus,
	"com.tradefxl.crm.api.entities.customer.bonuses.enums.BonusPromotion" : BonusPromotion,
	"com.tradefxl.crm.api.enums.customer.TradingFrequency" : TradingFrequency,
	"com.tradefxl.crm.api.enums.TradingAccountInstrumentType" : TradingAccountInstrumentType,
	"com.tradefxl.crm.api.enums.PriorityTypes" : PriorityTypes,
	"com.tradefxl.crm.api.enums.TTAClearingCode" : TTAClearingCode,
	"com.tradefxl.crm.api.enums.DocumentStatus" : DocumentStatus,
	"com.tradefxl.crm.api.enums.AutomaticTradingType" : AutomaticTradingType,
	"com.tradefxl.crm.api.enums.WithdrawalRequestStatus" : WithdrawalRequestStatus,
	"com.tradefxl.crm.api.enums.DialerType" : DialerType,
	"com.tradefxl.crm.api.entities.finance.TransactionEndPointGateway" : TransactionEndPointGateway,
	"com.tradefxl.crm.api.enums.customer.Objective" : Objective,
	"com.tradefxl.crm.api.enums.customer.Industry" : Industry,
	"com.tradefxl.crm.api.enums.MarketingType" : MarketingType,
	"com.tradefxl.crm.api.entities.finance.TransactionStatus" : TransactionStatus,
	"com.tradefxl.crm.api.enums.customer.ComplianceSuspendedGround" : ComplianceSuspendedGround,
	"com.tradefxl.crm.api.entities.finance.creditcard.CreditCardType" : CreditCardType,
	"com.tradefxl.crm.api.enums.customer.RegistrationReason" : RegistrationReason,
	"com.tradefxl.crm.api.enums.TradingExperienceAsset_WithDeprecated" : TradingExperienceAsset_WithDeprecated,
	"com.tradefxl.crm.api.enums.TradingExperienceAsset_Deprecated" : TradingExperienceAsset_Deprecated,
	"com.tradefxl.crm.api.enums.TradingExperienceAsset" : TradingExperienceAsset,
	"com.tradefxl.crm.api.enums.OneClickClosingAccountStatusGround" : OneClickClosingAccountStatusGround,
	"com.tradefxl.crm.api.entities.customer.contact.CustomerContactType" : CustomerContactType,
	"com.tradefxl.crm.api.enums.customer.CustomerPotential" : CustomerPotential,
	"com.tradefxl.crm.api.enums.ConfidentialEntityPropertyUIPlacement" : ConfidentialEntityPropertyUIPlacement,
	"com.tradefxl.crm.api.enums.TBAValidationType" : TBAValidationType,
	"com.tradefxl.crm.api.enums.RebateProgram" : RebateProgram,
	"com.tradefxl.crm.api.enums.PanelItemType" : PanelItemType,
	"com.tradefxl.crm.api.enums.DeactivationSource" : DeactivationSource,
	"com.tradefxl.crm.api.enums.customer.DepositRiskGroup" : DepositRiskGroup,
	"com.tradefxl.crm.api.enums.customer.StudyField" : StudyField,
	"com.tradefxl.crm.api.enums.customer.TradingExperienceScf" : TradingExperienceScf,
	"com.tradefxl.crm.api.enums.CustomerEngagementState" : CustomerEngagementState,
	"com.tradefxl.crm.api.enums.UserEmailType" : UserEmailType,
	"com.tradefxl.crm.api.enums.WorldCheckValidationPoint" : WorldCheckValidationPoint,
	"com.tradefxl.crm.api.enums.PendingBonusType" : PendingBonusType,
	"com.tradefxl.crm.api.enums.TradingAccountMode" : TradingAccountMode,
	"com.tradefxl.crm.api.enums.ScoreType" : ScoreType,
	"com.tradefxl.crm.api.enums.customer.NetWorth" : NetWorth,
	"com.tradefxl.crm.api.enums.ProductConfiguration" : ProductConfiguration,
	"com.tradefxl.crm.api.enums.ReferralSource" : ReferralSource,
	"com.tradefxl.crm.api.enums.VIPLevel" : VIPLevel,
	"com.tradefxl.crm.api.enums.customer.ServiceType" : ServiceType,
	"com.tradefxl.crm.api.enums.ActionType" : ActionType,
	"com.tradefxl.crm.api.entities.assignment.DispatcherType" : DispatcherType,
	"com.tradefxl.crm.api.entities.finance.EndPointType" : EndPointType,
	"com.tradefxl.crm.api.enums.VipOfferGroup" : VipOfferGroup,
	"com.tradefxl.crm.api.enums.AppSourceType" : AppSourceType,
	"com.tradefxl.crm.api.enums.SolidpayConfigPaymentMethod" : SolidpayConfigPaymentMethod,
	"com.tradefxl.crm.api.enums.customer.CustomerRegistrationLevel" : CustomerRegistrationLevel,
	"com.tradefxl.crm.api.enums.AMLScoreConfigValue" : AMLScoreConfigValue,
	"com.tradefxl.crm.api.entities.customer.contact.CustomerContactStatus" : CustomerContactStatus,
	"com.tradefxl.crm.api.enums.customer.MarketingEmailStatus" : MarketingEmailStatus,
	"com.tradefxl.crm.api.entities.finance.RejectionReason" : RejectionReason,
	"com.tradefxl.crm.api.enums.CustomerSpecialStateType" : CustomerSpecialStateType,
	"com.tradefxl.crm.api.enums.OneClickClosingAccountStatus" : OneClickClosingAccountStatus,
	"com.tradefxl.crm.api.enums.PayGatePaymentType" : PayGatePaymentType,
	"com.tradefxl.crm.api.enums.UserStatus" : UserStatus,
	"com.tradefxl.crm.api.enums.customer.CompensationFactorType" : CompensationFactorType,
	"com.tradefxl.crm.api.enums.SubscriptionStatus" : SubscriptionStatus,
	"com.tradefxl.crm.api.enums.customer.GracePeriodStatus" : GracePeriodStatus,
	"com.tradefxl.crm.api.enums.customer.NatureOfTransactions" : NatureOfTransactions,
	"com.tradefxl.crm.api.enums.customer.TradingFrequencyScf" : TradingFrequencyScf,
	"com.tradefxl.crm.api.enums.customer.ClientClassification" : ClientClassification,
	"com.tradefxl.crm.api.enums.UserType" : UserType,
	"com.tradefxl.crm.api.enums.PaymentAsiaPaymentType" : PaymentAsiaPaymentType,
	"com.tradefxl.crm.api.enums.RouteGroup" : RouteGroup,
	"com.tradefxl.crm.api.enums.customer.QuestionnaireQuestionValidator" : QuestionnaireQuestionValidator,
	"com.tradefxl.crm.api.enums.customer.ConfirmationStatus" : ConfirmationStatus,
	"com.tradefxl.crm.api.enums.PreferredDepositMethod" : PreferredDepositMethod,
	"com.tradefxl.crm.api.enums.TradingGoal" : TradingGoal,
	"com.tradefxl.crm.api.enums.TotalDepositPotential_WithDeprecated" : TotalDepositPotential_WithDeprecated,
	"com.tradefxl.crm.api.enums.TotalDepositPotential_Deprecated" : TotalDepositPotential_Deprecated,
	"com.tradefxl.crm.api.enums.TotalDepositPotential" : TotalDepositPotential,
	"com.tradefxl.crm.api.enums.BrandBrokerStatus" : BrandBrokerStatus,
	"com.tradefxl.crm.api.enums.customer.CounterpartEntityType" : CounterpartEntityType,
	"com.tradefxl.crm.api.enums.customer.QuestionnaireStaticQuestionValidator" : QuestionnaireStaticQuestionValidator,
	"com.tradefxl.crm.api.entities.customer.wc.CustomerWorldCheckStatus" : CustomerWorldCheckStatus,
	"com.tradefxl.crm.api.enums.customer.ApprovalStatus" : ApprovalStatus,
	"com.tradefxl.crm.api.enums.SasUserRole" : SasUserRole,
	"com.tradefxl.crm.api.enums.WithdrawalValidationType" : WithdrawalValidationType,
	"com.tradefxl.crm.api.enums.OnlineStatus" : OnlineStatus,
	"com.tradefxl.crm.api.enums.SaxoTemplateType" : SaxoTemplateType,
	"com.tradefxl.crm.api.enums.SystemErrorSeverity" : SystemErrorSeverity,
	"com.tradefxl.crm.api.enums.TradingAccountType" : TradingAccountType,
	"com.tradefxl.crm.api.enums.CreditLineStatus" : CreditLineStatus,
	"com.tradefxl.crm.api.entities.finance.TransactionType" : TransactionType,
	"com.tradefxl.crm.api.enums.AScoreLevel" : AScoreLevel,
	"com.tradefxl.crm.api.enums.SolidPayPaymentType" : SolidPayPaymentType,
	"com.tradefxl.crm.api.enums.CustomerAccountType" : CustomerAccountType,
	"com.tradefxl.crm.api.entities.finance.manual.MethodType" : MethodType,
	"com.tradefxl.crm.api.enums.BonusPaymentType" : BonusPaymentType,
	"com.tradefxl.crm.api.enums.customer.GrossIncome" : GrossIncome,
	"com.tradefxl.crm.api.enums.TradingExperienceCompany" : TradingExperienceCompany,
	"com.tradefxl.crm.api.enums.EnvoyPaymentType" : EnvoyPaymentType,
	"com.tradefxl.crm.api.enums.CCDocumentRejectionReasonBack" : CCDocumentRejectionReasonBack,
	"com.tradefxl.crm.api.enums.customer.CustomerQuestionnaireStatus" : CustomerQuestionnaireStatus,
	"com.tradefxl.crm.api.enums.TitleTransfer_WithDeprecated" : TitleTransfer_WithDeprecated,
	"com.tradefxl.crm.api.enums.TitleTransfer_Deprecated" : TitleTransfer_Deprecated,
	"com.tradefxl.crm.api.enums.TitleTransfer" : TitleTransfer,
	"com.tradefxl.crm.api.enums.BonusRequestType" : BonusRequestType,
	"com.tradefxl.crm.api.enums.TradingExperiencePeriod" : TradingExperiencePeriod,
	"com.tradefxl.crm.api.enums.UserRole" : UserRole,
	"com.tradefxl.crm.api.enums.customer.AnticipatedTradingTurnover" : AnticipatedTradingTurnover,
	"com.tradefxl.crm.api.enums.customer.ComplianceStage" : ComplianceStage,
	"com.tradefxl.crm.api.enums.VipOfferType" : VipOfferType,
	"com.tradefxl.crm.api.enums.customer.QuestionnaireQuestionType" : QuestionnaireQuestionType,
	"com.tradefxl.crm.api.enums.ECDDOption" : ECDDOption,
	"com.tradefxl.crm.api.enums.customer.TermsConditionsNewVersion" : TermsConditionsNewVersion,
	"com.tradefxl.crm.api.enums.TransactionReasonName" : TransactionReasonName,
	"com.tradefxl.crm.api.entities.finance.TransactionKind" : TransactionKind,
	"com.tradefxl.crm.api.enums.ForbiddenJurisdictionType" : ForbiddenJurisdictionType,
	"com.tradefxl.crm.api.enums.customer.SecurityQuestion" : SecurityQuestion,
	"com.tradefxl.crm.api.enums.customer.bonuses.task.BonusTaskRecordStatus" : BonusTaskRecordStatus,
	"com.tradefxl.crm.api.enums.ProcessingType" : ProcessingType,
	"com.tradefxl.crm.api.enums.TokenType" : TokenType,
	"com.tradefxl.crm.api.enums.customer.TradingTransactionsVolumeScf" : TradingTransactionsVolumeScf,
	"com.tradefxl.crm.api.enums.PostVerificationStatus" : PostVerificationStatus,
	"com.tradefxl.crm.api.enums.TransactionProcessingType" : TransactionProcessingType,
	"com.tradefxl.crm.api.enums.customer.FatcaReportable" : FatcaReportable,
	"com.tradefxl.crm.api.enums.PostRejectionReason" : PostRejectionReason,
	"com.tradefxl.crm.api.enums.TBARequestStatus" : TBARequestStatus,
	"com.tradefxl.crm.api.enums.customer.EducationLevel" : EducationLevel,
	"com.tradefxl.crm.api.enums.TradingExperienceInstrument_WithDeprecated" : TradingExperienceInstrument_WithDeprecated,
	"com.tradefxl.crm.api.enums.TradingExperienceInstrument_Deprecated" : TradingExperienceInstrument_Deprecated,
	"com.tradefxl.crm.api.enums.TradingExperienceInstrument" : TradingExperienceInstrument,
	"com.tradefxl.crm.api.entities.finance.creditcard.CreditCardStatus" : CreditCardStatus,
	"com.tradefxl.crm.api.enums.GBGValidationPoint" : GBGValidationPoint,
	"com.tradefxl.crm.api.enums.CUPPaymentType" : CUPPaymentType,
	"com.tradefxl.crm.api.entities.customer.gdb.GBGStatus" : GBGStatus,
	"com.tradefxl.crm.api.enums.customer.TradingExperience" : TradingExperience,
	"com.tradefxl.crm.api.enums.customer.QuestionnaireStaticQuestionType" : QuestionnaireStaticQuestionType,
	"com.tradefxl.crm.api.enums.CCDocumentRejectionReasonFront" : CCDocumentRejectionReasonFront,
	"com.tradefxl.crm.api.enums.EndpointProcessingType" : EndpointProcessingType,
	"com.tradefxl.crm.api.enums.RegistrationSource" : RegistrationSource,
	"com.tradefxl.crm.api.enums.TradingAccountStatus" : TradingAccountStatus,
	"com.tradefxl.crm.api.enums.BaoFooPaymentType" : BaoFooPaymentType,
	"com.tradefxl.crm.api.enums.customer.QuestionnaireQuestionDerivingStrategy" : QuestionnaireQuestionDerivingStrategy,
	"com.tradefxl.crm.api.enums.CustomerRegistrationStatus" : CustomerRegistrationStatus,
	"com.tradefxl.crm.api.enums.customer.TINAbsenceReason" : TINAbsenceReason,
	"com.tradefxl.crm.api.enums.customer.MaliciousScanStatus" : MaliciousScanStatus,
	"com.tradefxl.crm.api.enums.customer.MigrationConfirmationStatus" : MigrationConfirmationStatus,
	"com.tradefxl.crm.api.enums.Priority" : Priority,
	"com.tradefxl.crm.api.entities.regulation.RegulationStatus" : RegulationStatus,
	"descriptors.ValueFormatter" : ValueFormatter,
	"descriptors.ValueRenderer" : ValueRenderer,
	"printers.PrinterUtils$FilterType" : FilterType
}
